/* eslint-disable indent */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import { useState, useEffect, useMemo } from "react";
import { useForm, FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { FaBan, FaEdit, FaKey, FaTrash, FaUndo } from "react-icons/fa";
import { FiSave } from "react-icons/fi";
import { ListaEdificios } from "../../components";
import { AgenciasDropdown, matchAgenciaFilter } from "../../components/AgenciasDropdown";
import { Header } from "../../components/Header";
import KebabMenu from "../../components/KebabMenu";
import { isAdmin, puedeAsignarEdificios, puedeAsignarClientes } from "../../constants/permisos";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import {
  saveUsuario,
  getUsers,
  getIntermediarios,
  updateUsuario,
  deleteUsuario,
  setUsuarioHabilitado,
  setUsuarioEdificios,
  getUsuarioClientes,
  setUsuarioClientes,
  getClientes,
  getContactosPendientes,
  construirFilasPendientes,
  guardarContacto,
  existeUsuarioConEmail,
  vincularUsuarioEntidad,
  emailsExistentesUsuarios,
  emailsExistentesContactos,
  crearUsuarioDesdePendiente,
  agregarBlacklist,
  listarBlacklist,
  contarBlacklist,
  quitarBlacklist,
  listarContactos,
  contarContactos,
  quitarContacto,
  getRebotes,
  contarRebotes,
  marcarReboteObsoleto,
  marcarRebotesObsoletosBulk,
  getRebotesObsoletos,
  ORIGEN_NUEVO,
  ESTADO_SOLO_MAILING,
  ESTADO_DESCARTADO,
  BLACKLIST_EMAIL,
  BLACKLIST_DOMINIO,
} from "../../utils";
import { client as supabaseClient } from "../../utils/supabase";
import styles from "./stylesUsuarios.module.scss";

// Valores centinela del <select> de roles: activan vistas especiales en lugar de
// filtrar por rol. No son roles reales, así que nunca coinciden con usuario.rol.
// (B2 sumará __descartados__ y __solomailing__.)
const PENDIENTES_SENTINEL = "__pendientes__";
const BLACKLIST_SENTINEL = "__blacklist__";
const DESCARTADOS_SENTINEL = "__descartados__";
const SOLOMAILING_SENTINEL = "__solomailing__";
const REBOTES_SENTINEL = "__rebotes__";
const VISTAS_SENTINEL = [
  PENDIENTES_SENTINEL,
  BLACKLIST_SENTINEL,
  DESCARTADOS_SENTINEL,
  SOLOMAILING_SENTINEL,
  REBOTES_SENTINEL,
];

export const Usuarios = () => {
  const methods = useForm();
  // Form aislado del modal "Asignar edificios" (rol=edificio) — separado de `methods`
  // (el alta) para no pisar el estado del <ListaEdificios> del modal de creación.
  const edificiosMethods = useForm();
  const [edificiosModal, setEdificiosModal] = useState({ show: false, usuario: null });
  const [guardandoEdificios, setGuardandoEdificios] = useState(false);
  // Modal "Clientes vinculados" (rol=agencia) — vínculos en la tabla puente usuarios_clientes.
  // `seleccion` = Set de cliente_id elegidos (por ID, 10.7); se carga fresco al abrir.
  const [clientesModal, setClientesModal] = useState({ show: false, usuario: null });
  const [clientesSeleccion, setClientesSeleccion] = useState(() => new Set());
  const [cargandoVinculos, setCargandoVinculos] = useState(false);
  const [guardandoClientes, setGuardandoClientes] = useState(false);
  const [filtroClientesModal, setFiltroClientesModal] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [sortColumn, setSortColumn] = useState("nombre");
  const [sortDirection, setSortDirection] = useState("asc");
  // Orden de la vista de pendientes. null = orden natural (ultima_fecha desc,
  // veces_visto desc) que arma construirFilasPendientes; se activa al clickear un header.
  const [pendSortColumn, setPendSortColumn] = useState(null);
  const [pendSortDirection, setPendSortDirection] = useState("asc");
  const [newUser, setNewUser] = useState({
    nombre: "",
    apellido: "",
    email: "",
    rol: "",
    edificiosOk: "",
    entidad: "",
    cargo: "",
  });
  const [showListaEdificios, setShowListaEdificios] = useState(false);
  const [intermediarios, setIntermediarios] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [clientes, setClientes] = useState([]);
  const [searchNombre, setSearchNombre] = useState("");
  const [searchApellido, setSearchApellido] = useState("");
  const [searchAgencia, setSearchAgencia] = useState("");
  const [searchCliente, setSearchCliente] = useState("");
  const [searchCargo, setSearchCargo] = useState("");
  const [searchCorreo, setSearchCorreo] = useState("");
  const [filtroRol, setFiltroRol] = useState("");
  const [selectedRoles, setSelectedRoles] = useState({
    agencia: true,
    cliente: true,
    edificio: true,
  });
  const [showModal, setShowModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState({ show: false, usuario: null });
  const [passwordInput, setPasswordInput] = useState("");

  // Vista de curación de contactos (fase 1: solo lectura). Se entra desde el
  // <select> de roles eligiendo la opción centinela, no con un toggle aparte.
  const [pendientes, setPendientes] = useState([]);
  const [loadingPendientes, setLoadingPendientes] = useState(false);
  const [pendientesCargados, setPendientesCargados] = useState(false);
  const [curandoEmail, setCurandoEmail] = useState(null);
  const [descartarModal, setDescartarModal] = useState({ show: false, fila: null });
  const [motivoDescarte, setMotivoDescarte] = useState("");
  const [blacklistModal, setBlacklistModal] = useState({ show: false, fila: null });
  const [motivoBlacklist, setMotivoBlacklist] = useState("");
  // Vista de gestión del blacklist (fase B1: es una vista del dropdown, no un modal).
  const [blacklistEntradas, setBlacklistEntradas] = useState([]);
  const [blacklistCount, setBlacklistCount] = useState(0);
  const [loadingBlacklist, setLoadingBlacklist] = useState(false);
  const [nuevaEntradaBL, setNuevaEntradaBL] = useState({ tipo: BLACKLIST_EMAIL, valor: "", pais: "", motivo: "" });
  const [guardandoBL, setGuardandoBL] = useState(false);
  // Vistas de contactos curados (fase B2): descartados y solo_mailing.
  const [contactosVista, setContactosVista] = useState([]);
  const [loadingContactosVista, setLoadingContactosVista] = useState(false);
  const [descartadosCount, setDescartadosCount] = useState(0);
  const [soloMailingCount, setSoloMailingCount] = useState(0);
  // Vista de rebotes (fase R2): duros pendientes de crm_rebotes.
  const [rebotesVista, setRebotesVista] = useState([]);
  const [loadingRebotes, setLoadingRebotes] = useState(false);
  const [rebotesCount, setRebotesCount] = useState(0);
  const [procesandoRebote, setProcesandoRebote] = useState(null);
  // Fase R3: set de emails obsoletos (para el badge en la tabla normal) + bulk.
  const [obsoletosSet, setObsoletosSet] = useState(() => new Set());
  const [bulkRebotesModal, setBulkRebotesModal] = useState(false);
  const [procesandoBulkRebotes, setProcesandoBulkRebotes] = useState(false);
  // Fila de pendientes que se está registrando como usuario (null = alta normal).
  const [registroPendiente, setRegistroPendiente] = useState(null);
  const [guardandoRegistro, setGuardandoRegistro] = useState(false);
  const [vincularModal, setVincularModal] = useState({ show: false, fila: null });
  const [entidadVinculo, setEntidadVinculo] = useState("");
  const [guardandoVinculo, setGuardandoVinculo] = useState(false);
  // Fase D1: alta masiva de todos los contactos "Nuevo" de un dominio a un rol.
  const [asignarDominioModal, setAsignarDominioModal] = useState({ show: false, dominio: "" });
  const [asignarRol, setAsignarRol] = useState("");
  const [asignarEntidad, setAsignarEntidad] = useState("");
  const [procesandoAsignar, setProcesandoAsignar] = useState(false);
  // Fase D2: descarte masivo de todos los "Nuevo" de un dominio.
  const [descartarDominioModal, setDescartarDominioModal] = useState({ show: false, dominio: "" });
  const [motivoDescarteDominio, setMotivoDescarteDominio] = useState("");
  const [procesandoDescarteDominio, setProcesandoDescarteDominio] = useState(false);

  // Las vistas especiales se derivan del <select> de roles: elegir un centinela
  // activa su vista; cualquier rol real o "Todos los roles" vuelve a la tabla normal.
  const modoPendientes = filtroRol === PENDIENTES_SENTINEL;
  const modoBlacklist = filtroRol === BLACKLIST_SENTINEL;
  const modoDescartados = filtroRol === DESCARTADOS_SENTINEL;
  const modoSoloMailing = filtroRol === SOLOMAILING_SENTINEL;
  const modoRebotes = filtroRol === REBOTES_SENTINEL;
  const modoContactos = modoDescartados || modoSoloMailing;
  const esVistaSentinel = VISTAS_SENTINEL.includes(filtroRol);

  const { pais, rol, id: userId } = useAuthContext();
  const puedeVerTodosLosRoles = rol === ROLES.GERENCIA && isAdmin(userId);
  const puedeEditar = rol !== ROLES.INVERSOR;
  const esAdmin = isAdmin(userId);
  const puedeSetearPassword = [1, 4, 7, 9, 139].includes(Number(userId));
  const puedeAsignarEdif = puedeAsignarEdificios(userId);
  const puedeAsignarCli = puedeAsignarClientes(userId);

  const paisMap = {
    Chile: "CHI",
    Perú: "PER",
    Uruguay: "URU",
    Region: "REG",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getClientes({ pais });
        setClientes(data || []);
      } catch (error) {
        console.error("Error al obtener clientes:", error);
        setClientes([]);
      }
    };

    fetchData();
  }, [pais]);

  const fetchUsuarios = async () => {
    try {
      const newUsuarios = await getUsers({ includeDisabled: esAdmin });
      setUsuarios(newUsuarios);
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    }
  };

  useEffect(() => {
    fetchUsuarios();
    const fetchIntermediarios = async () => {
      try {
        const newIntermediarios = await getIntermediarios({ pais });
        setIntermediarios(newIntermediarios);
      } catch (error) {
        console.error("Error al obtener intermediarios:", error);
      }
    };
    fetchIntermediarios();
  }, [pais]);

  // El RPC agrega ~53k filas: se dispara solo al entrar a la vista, una vez por país.
  useEffect(() => {
    setPendientes([]);
    setPendientesCargados(false);
  }, [pais]);

  useEffect(() => {
    if (!modoPendientes || pendientesCargados) return;

    const fetchPendientes = async () => {
      setLoadingPendientes(true);
      try {
        const data = await getContactosPendientes({ pais: paisMap[pais] || "CHI" });
        setPendientes(data);
        setPendientesCargados(true);
      } catch (error) {
        console.error("Error al obtener contactos pendientes:", error);
        toast.error("Error al cargar contactos pendientes");
      } finally {
        setLoadingPendientes(false);
      }
    };

    fetchPendientes();
  }, [modoPendientes, pendientesCargados, pais]);

  // COUNT barato del blacklist al montar, para el label "Blacklist (N)" del select.
  useEffect(() => {
    let vivo = true;
    contarBlacklist().then((n) => {
      if (vivo && n >= 0) setBlacklistCount(n);
    });
    return () => {
      vivo = false;
    };
  }, []);

  // Al entrar a la vista de blacklist: limpia el form y carga la lista.
  useEffect(() => {
    if (!modoBlacklist) return;
    setNuevaEntradaBL({ tipo: BLACKLIST_EMAIL, valor: "", pais: "", motivo: "" });
    cargarBlacklist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modoBlacklist]);

  // COUNT barato de contactos (descartados / solo_mailing) por país, para los labels.
  useEffect(() => {
    let vivo = true;
    const pc = paisMap[pais] || "CHI";
    contarContactos({ estado: ESTADO_DESCARTADO, pais: pc }).then((n) => {
      if (vivo && n >= 0) setDescartadosCount(n);
    });
    contarContactos({ estado: ESTADO_SOLO_MAILING, pais: pc }).then((n) => {
      if (vivo && n >= 0) setSoloMailingCount(n);
    });
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pais]);

  // Al entrar a una vista de contactos: carga la lista del estado correspondiente.
  useEffect(() => {
    if (!modoContactos) return;
    const estado = modoDescartados ? ESTADO_DESCARTADO : ESTADO_SOLO_MAILING;
    const fetchContactos = async () => {
      setLoadingContactosVista(true);
      const data = await listarContactos({ estado, pais: paisMap[pais] || "CHI" });
      setContactosVista(data);
      if (modoDescartados) setDescartadosCount(data.length);
      else setSoloMailingCount(data.length);
      setLoadingContactosVista(false);
    };
    fetchContactos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modoContactos, modoDescartados, pais]);

  // COUNT barato de rebotes duros pendientes por país, para el label "Rebotes (N)".
  useEffect(() => {
    let vivo = true;
    const pc = paisMap[pais] || "CHI";
    contarRebotes({ pais: pc }).then((n) => {
      if (vivo && n >= 0) setRebotesCount(n);
    });
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pais]);

  // Set de emails obsoletos del país, para el badge "Obsoleto" en la tabla normal.
  // Se recarga por país; los handlers de marcado (individual/bulk) lo refrescan.
  useEffect(() => {
    let vivo = true;
    getRebotesObsoletos({ pais: paisMap[pais] || "CHI" }).then(({ emails }) => {
      if (vivo) setObsoletosSet(new Set(emails));
    });
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pais]);

  // Refresca el set de obsoletos (tras marcar). Devuelve el Set nuevo.
  const refrescarObsoletos = async () => {
    const { emails } = await getRebotesObsoletos({ pais: paisMap[pais] || "CHI" });
    setObsoletosSet(new Set(emails));
  };

  // Al entrar a la vista de rebotes: carga los duros pendientes del país.
  useEffect(() => {
    if (!modoRebotes) return;
    const fetchRebotes = async () => {
      setLoadingRebotes(true);
      const { filas } = await getRebotes({ pais: paisMap[pais] || "CHI" });
      setRebotesVista(filas);
      setRebotesCount(filas.length);
      setLoadingRebotes(false);
    };
    fetchRebotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modoRebotes, pais]);

  // Fase 2a: manda el contacto a `contactos` y lo saca de la lista de pendientes.
  const curarContacto = async (fila, estado, motivo) => {
    setCurandoEmail(fila.email);
    const { ok, duplicado, estadoExistente, error } = await guardarContacto({
      email: fila.email,
      pais: paisMap[pais] || "",
      nombre: fila.nombre,
      apellido: fila.apellido,
      estado,
      motivo,
      creadoPor: userId,
    });
    setCurandoEmail(null);

    if (ok) {
      setPendientes((prev) => prev.filter((p) => p.email !== fila.email));
      toast.success(
        estado === ESTADO_SOLO_MAILING ? `${fila.email} marcado como solo mailing` : `${fila.email} descartado`
      );
      return true;
    }

    if (duplicado) {
      // Ya estaba curado (otra sesión, o la lista quedó vieja): se saca igual,
      // porque el RPC tampoco lo devolvería en la próxima carga.
      setPendientes((prev) => prev.filter((p) => p.email !== fila.email));
      toast.error(`${fila.email} ya estaba registrado${estadoExistente ? ` como ${estadoExistente}` : ""}`);
      return true;
    }

    toast.error(error?.message || "No se pudo guardar el contacto");
    return false;
  };

  const handleSoloMailing = (fila) => curarContacto(fila, ESTADO_SOLO_MAILING, null);

  const handleAbrirDescartar = (fila) => {
    setMotivoDescarte("");
    setDescartarModal({ show: true, fila });
  };

  // Fase 2c: las filas "Sin cablear" ya son usuarios; solo les falta la entidad.
  const handleAbrirVincular = (fila) => {
    // La sugerencia de dominio sirve solo si apunta al mismo tipo que el rol del
    // usuario: un rol 'agencia' no se precarga con un cliente.
    const sugerenciaAplica = fila.sugerencia && fila.sugerencia.tipo === fila.rol;
    setEntidadVinculo(sugerenciaAplica ? String(fila.sugerencia.entidadId) : "");
    setVincularModal({ show: true, fila });
  };

  const handleConfirmarVincular = async () => {
    const { fila } = vincularModal;
    if (!fila || !entidadVinculo) return;

    setGuardandoVinculo(true);
    const { ok, usuario, error } = await vincularUsuarioEntidad({
      id: fila.usuarioId,
      rol: fila.rol,
      entidadId: entidadVinculo,
    });
    setGuardandoVinculo(false);

    if (!ok) {
      toast.error(error?.message || "No se pudo vincular el usuario");
      return;
    }

    // Estas filas se derivan del array `usuarios`, no del RPC: al reflejar el
    // update en memoria dejan de cumplir el filtro (agencia/cliente_id null) y
    // salen solas de la lista.
    setUsuarios((prev) => prev.map((u) => (u.id === usuario.id ? { ...u, ...usuario } : u)));
    setVincularModal({ show: false, fila: null });
    setEntidadVinculo("");
    toast.success(`${fila.email} vinculado correctamente`);
  };

  // Fase D1: alta masiva de todos los "Nuevo" de un dominio a un rol.
  const handleAbrirAsignarDominio = (fila) => {
    // Precarga la sugerencia unívoca del dominio (si la fila la trae).
    setAsignarRol(fila.sugerencia ? fila.sugerencia.tipo : "");
    setAsignarEntidad(fila.sugerencia ? String(fila.sugerencia.entidadId) : "");
    setAsignarDominioModal({ show: true, dominio: fila.dominio });
  };

  const handleConfirmarAsignarDominio = async () => {
    const dominio = asignarDominioModal.dominio;
    if (!dominio || !asignarRol) return;

    const necesitaEntidad = asignarRol === "cliente" || asignarRol === "agencia";
    if (necesitaEntidad && !asignarEntidad) {
      toast.error(`Seleccioná un ${asignarRol === "agencia" ? "intermediario" : "cliente"}`);
      return;
    }

    const paisCode = paisMap[pais] || "";
    const filasDominio = filasPendientes.filter((f) => f.origen === ORIGEN_NUEVO && f.dominio === dominio);
    if (filasDominio.length === 0) {
      toast.error("No hay contactos de ese dominio en la lista");
      return;
    }

    setProcesandoAsignar(true);
    let creados = 0;
    let saltados = 0;
    let errores = 0;
    const resueltos = new Set(); // emails a sacar de pendientes (creados o ya existentes)

    if (asignarRol === "mailing") {
      for (const f of filasDominio) {
        const { ok, duplicado } = await guardarContacto({
          email: f.email,
          pais: paisCode,
          nombre: f.nombre,
          apellido: f.apellido,
          estado: ESTADO_SOLO_MAILING,
          motivo: null,
          creadoPor: userId,
        });
        if (ok) {
          creados++;
          resueltos.add(f.email);
        } else if (duplicado) {
          saltados++;
          resueltos.add(f.email);
        } else {
          errores++;
        }
      }
    } else {
      // cliente / agencia / edificio → usuarios. Chequeo BATCH de existentes (1 query).
      const { emails: existentes } = await emailsExistentesUsuarios({ dominio, pais: paisCode });
      for (const f of filasDominio) {
        if (existentes.has(f.email.toLowerCase())) {
          saltados++;
          resueltos.add(f.email);
          continue;
        }
        const { ok, duplicado } = await crearUsuarioDesdePendiente({
          email: f.email,
          nombre: f.nombre,
          apellido: f.apellido,
          rol: asignarRol,
          entidadId: necesitaEntidad ? asignarEntidad : null,
          pais: paisCode,
        });
        if (ok) {
          creados++;
          resueltos.add(f.email);
        } else if (duplicado) {
          saltados++;
          resueltos.add(f.email);
        } else {
          errores++;
        }
      }
    }

    setProcesandoAsignar(false);
    // Quitado optimista: sale de pendientes lo resuelto (los errores quedan).
    setPendientes((prev) => prev.filter((p) => !resueltos.has(p.email)));
    setAsignarDominioModal({ show: false, dominio: "" });
    setAsignarRol("");
    setAsignarEntidad("");
    toast.success(`${creados} creado(s), ${saltados} ya existía(n)${errores ? `, ${errores} con error` : ""}`);
  };

  // Fase D2: descarta de una todos los "Nuevo" de un dominio (a `contactos`).
  const handleAbrirDescartarDominio = (fila) => {
    setMotivoDescarteDominio("");
    setDescartarDominioModal({ show: true, dominio: fila.dominio });
  };

  const handleConfirmarDescartarDominio = async () => {
    const dominio = descartarDominioModal.dominio;
    if (!dominio) return;

    const paisCode = paisMap[pais] || "";
    const filasDominio = filasPendientes.filter((f) => f.origen === ORIGEN_NUEVO && f.dominio === dominio);
    if (filasDominio.length === 0) {
      toast.error("No hay contactos de ese dominio en la lista");
      return;
    }

    setProcesandoDescarteDominio(true);
    let descartados = 0;
    let saltados = 0;
    let errores = 0;
    const resueltos = new Set(); // emails a sacar de pendientes (descartados o ya existentes)

    // Chequeo BATCH de existentes en contactos (cualquier estado) — 1 query.
    const { emails: existentes } = await emailsExistentesContactos({ dominio, pais: paisCode });

    for (const f of filasDominio) {
      if (existentes.has(f.email.toLowerCase())) {
        saltados++;
        resueltos.add(f.email);
        continue;
      }
      const { ok, duplicado } = await guardarContacto({
        email: f.email,
        pais: paisCode,
        nombre: f.nombre,
        apellido: f.apellido,
        estado: ESTADO_DESCARTADO,
        motivo: motivoDescarteDominio,
        creadoPor: userId,
      });
      if (ok) {
        descartados++;
        resueltos.add(f.email);
      } else if (duplicado) {
        saltados++;
        resueltos.add(f.email);
      } else {
        errores++;
      }
    }

    setProcesandoDescarteDominio(false);
    // Quitado optimista: sale de pendientes lo resuelto (los errores quedan).
    setPendientes((prev) => prev.filter((p) => !resueltos.has(p.email)));
    setDescartarDominioModal({ show: false, dominio: "" });
    setMotivoDescarteDominio("");
    toast.success(`${descartados} descartado(s), ${saltados} ya existía(n)${errores ? `, ${errores} con error` : ""}`);
  };

  const handleConfirmarDescartar = async () => {
    const { fila } = descartarModal;
    if (!fila) return;

    const exito = await curarContacto(fila, ESTADO_DESCARTADO, motivoDescarte);
    if (exito) {
      setDescartarModal({ show: false, fila: null });
      setMotivoDescarte("");
    }
  };

  // Fase C: quitado optimista de pendientes al blacklistear, sin recargar el RPC.
  // tipo email → saca la fila de ese email; tipo dominio → saca todas las de ese
  // dominio de una. Mismo patrón que el quitado optimista de "Sin cablear".
  const quitarPendientesPorBlacklist = (tipo, valor) => {
    const v = String(valor || "")
      .trim()
      .toLowerCase();
    if (!v) return;
    setPendientes((prev) =>
      prev.filter((p) => {
        const email = (p.email || "").toLowerCase();
        if (tipo === BLACKLIST_DOMINIO) return (email.split("@")[1] || "") !== v;
        return email !== v;
      })
    );
  };

  // Fase 5a/C: manda a `blacklist` un email o un dominio completo de una fila.
  const handleAbrirBlacklist = (fila, tipo = BLACKLIST_EMAIL) => {
    setMotivoBlacklist("");
    setBlacklistModal({ show: true, fila, tipo });
  };

  const handleConfirmarBlacklist = async () => {
    const { fila, tipo } = blacklistModal;
    if (!fila) return;

    const esDominio = tipo === BLACKLIST_DOMINIO;
    const valor = esDominio ? fila.dominio : fila.email;

    setCurandoEmail(fila.email);
    const { ok, duplicado, error } = await agregarBlacklist({
      tipo: esDominio ? BLACKLIST_DOMINIO : BLACKLIST_EMAIL,
      valor,
      // dominio completo = Ambos (pais NULL); email = país activo.
      pais: esDominio ? null : paisMap[pais] || null,
      motivo: motivoBlacklist,
      creadoPor: userId,
    });
    setCurandoEmail(null);

    if (ok || duplicado) {
      // El RPC excluye lo blacklisteado; el quitado optimista lo saca ya.
      quitarPendientesPorBlacklist(esDominio ? BLACKLIST_DOMINIO : BLACKLIST_EMAIL, valor);
      setBlacklistModal({ show: false, fila: null });
      setMotivoBlacklist("");
      toast[ok ? "success" : "error"](ok ? `${valor} agregado a blacklist` : `${valor} ya estaba en blacklist`);
      return;
    }

    toast.error(error?.message || "No se pudo agregar a blacklist");
  };

  // Gestión del blacklist (fase B1: vista del dropdown). Carga la lista y ajusta
  // el N del label desde el largo real.
  const cargarBlacklist = async () => {
    setLoadingBlacklist(true);
    const data = await listarBlacklist();
    setBlacklistEntradas(data);
    setBlacklistCount(data.length);
    setLoadingBlacklist(false);
  };

  const handleAgregarBlacklistManual = async () => {
    if (!nuevaEntradaBL.valor.trim()) {
      toast.error("Ingresá un valor");
      return;
    }

    // Auto-detección: el "@" manda. Corrige el selector si eligieron mal, para no
    // guardar nunca un dominio como email ni al revés.
    const tipoDetectado = nuevaEntradaBL.valor.includes("@") ? BLACKLIST_EMAIL : BLACKLIST_DOMINIO;
    const corregido = tipoDetectado !== nuevaEntradaBL.tipo;

    setGuardandoBL(true);
    const { ok, duplicado, error } = await agregarBlacklist({
      tipo: tipoDetectado,
      valor: nuevaEntradaBL.valor,
      // "" en el selector = Ambos = pais NULL.
      pais: nuevaEntradaBL.pais || null,
      motivo: nuevaEntradaBL.motivo,
      creadoPor: userId,
    });
    setGuardandoBL(false);

    if (ok) {
      // agregarBlacklist normaliza (dominio sin @): reproducimos para el quitado.
      const valorNorm =
        tipoDetectado === BLACKLIST_DOMINIO && nuevaEntradaBL.valor.includes("@")
          ? nuevaEntradaBL.valor.trim().toLowerCase().split("@").pop()
          : nuevaEntradaBL.valor.trim().toLowerCase();
      quitarPendientesPorBlacklist(tipoDetectado, valorNorm);
      toast.success(
        corregido
          ? `Se guardó como ${tipoDetectado === BLACKLIST_DOMINIO ? "Dominio" : "Email"}`
          : "Agregado a blacklist"
      );
      setNuevaEntradaBL({ tipo: BLACKLIST_EMAIL, valor: "", pais: "", motivo: "" });
      cargarBlacklist();
      return;
    }
    if (duplicado) {
      toast.error("Ese valor ya estaba en blacklist");
      return;
    }
    toast.error(error?.message || "No se pudo agregar a blacklist");
  };

  const handleQuitarBlacklist = async (entrada) => {
    const { ok, error } = await quitarBlacklist(entrada.id);
    if (ok) {
      setBlacklistEntradas((prev) => prev.filter((e) => e.id !== entrada.id));
      setBlacklistCount((n) => Math.max(0, n - 1));
      toast.success(`${entrada.valor} quitado de blacklist`);
      return;
    }
    toast.error(error?.message || "No se pudo quitar del blacklist");
  };

  // Fase B2: quita una fila de contactos (descartado / solo_mailing). Al borrar,
  // el email vuelve a pendientes en la próxima carga del RPC.
  const handleQuitarContacto = async (entrada) => {
    const { ok, error } = await quitarContacto(entrada.id);
    if (ok) {
      setContactosVista((prev) => prev.filter((e) => e.id !== entrada.id));
      if (modoDescartados) setDescartadosCount((n) => Math.max(0, n - 1));
      else setSoloMailingCount((n) => Math.max(0, n - 1));
      toast.success(`${entrada.email} quitado`);
      return;
    }
    toast.error(error?.message || "No se pudo quitar el contacto");
  };

  // Fase R2: marca un rebote como obsoleto. NO borra ni toca usuarios/contactos;
  // solo cambia estado→procesado en crm_rebotes, lo que lo saca del circuito
  // (mailing + pendientes). Quitado optimista de la vista.
  const handleMarcarObsoleto = async (fila) => {
    setProcesandoRebote(fila.id);
    const { ok, error } = await marcarReboteObsoleto({ id: fila.id, creadoPor: userId });
    setProcesandoRebote(null);
    if (ok) {
      setRebotesVista((prev) => prev.filter((r) => r.id !== fila.id));
      setRebotesCount((n) => Math.max(0, n - 1));
      refrescarObsoletos(); // que el badge aparezca en la tabla normal
      toast.success(`${fila.email} marcado como obsoleto`);
      return;
    }
    toast.error(error?.message || "No se pudo marcar el rebote");
  };

  // Fase R3: marca EN BLOQUE todos los duros pendientes del país como obsoletos.
  // Vacía la vista (quitado optimista) y refresca el badge de la tabla normal.
  const handleBulkRebotes = async () => {
    setProcesandoBulkRebotes(true);
    const { ok, count, error } = await marcarRebotesObsoletosBulk({ pais: paisMap[pais] || "CHI", creadoPor: userId });
    setProcesandoBulkRebotes(false);
    setBulkRebotesModal(false);
    if (ok) {
      setRebotesVista([]);
      setRebotesCount(0);
      refrescarObsoletos();
      toast.success(`${count} marcado${count === 1 ? "" : "s"} como obsoleto${count === 1 ? "" : "s"}`);
      return;
    }
    toast.error(error?.message || "No se pudieron marcar los rebotes");
  };

  const handleEditClick = (usuario) => {
    setEditingUser({
      ...usuario,
      entidad:
        usuario.rol === "agencia" ? usuario.agencia || "" : usuario.rol === "cliente" ? usuario.cliente_id || "" : "",
      cargo: usuario.cargo || "",
      cargo_detalle: usuario.cargo_detalle || "",
      telefono: usuario.telefono || "",
      fecha_nacimiento: usuario.fecha_nacimiento || "",
    });
    setIsEditing(true);
  };

  // Modal "Asignar edificios" (Fase 1: solo estructura/visual, sin guardar).
  const handleAbrirEdificios = (usuario) => {
    // El store de react-hook-form (edificiosMethods) es del padre y PERSISTE entre
    // aperturas: RHF v7 conserva los valores al desmontar el modal, y el reset de
    // mount de ListaEdificios solo limpia los agregados, no las casillas
    // `edificio-${id}-checkbox`. Sin este reset, las tildes del usuario anterior se
    // acumulan sobre el siguiente. Limpiamos TODO el store antes de que ListaEdificios
    // remonte y aplique la preselección exclusiva del usuario elegido.
    edificiosMethods.reset();
    setEdificiosModal({ show: true, usuario });
  };

  const handleCerrarEdificios = () => {
    setEdificiosModal({ show: false, usuario: null });
  };

  const handleGuardarEdificios = async () => {
    const usuario = edificiosModal.usuario;
    if (!usuario) return;

    // Fuente CONFIABLE: el estado real de los checkboxes (misma fuente que pinta la
    // UI), NO el string `edificiosSeleccionados`. Ese string puede quedar en "" por la
    // carrera entre los dos effects de mount de ListaEdificios, que ambos lo resetean;
    // los campos `edificio-${id}-checkbox`, en cambio, no los pisa ese reset.
    const valores = edificiosMethods.getValues();
    const ids = Object.keys(valores)
      .map((k) => {
        const m = /^edificio-(\d+)-checkbox$/.exec(k);
        return m && valores[k] === true ? Number(m[1]) : null;
      })
      .filter((v) => v !== null)
      .sort((a, b) => a - b);

    // Normalizado: CSV de ids sin espacios, sin coma final. Sin selección → null.
    const csv = ids.length > 0 ? ids.join(",") : null;

    setGuardandoEdificios(true);
    const { data, error } = await setUsuarioEdificios(usuario.id, csv);
    setGuardandoEdificios(false);

    if (error) {
      toast.error("Error al guardar los edificios");
      return;
    }
    // Sin filas devueltas = RLS bloqueó el update. No es éxito.
    if (!data || data.length === 0) {
      toast.error("No se actualizó ninguna fila (permisos)");
      return;
    }

    const actualizado = data[0];
    setUsuarios((prev) =>
      prev.map((u) => (u.id === actualizado.id ? { ...u, edificiosOk: actualizado.edificiosOk } : u))
    );
    toast.success("Edificios actualizados");
    handleCerrarEdificios();
  };

  // Modal "Clientes vinculados" (rol=agencia). Calcado del de edificios, pero sobre la
  // tabla puente usuarios_clientes (relación N:N), no una columna CSV. Al abrir carga los
  // vínculos actuales frescos desde la DB (por ID); guardar reconcilia por diff.
  const handleAbrirClientes = async (usuario) => {
    setFiltroClientesModal("");
    setClientesSeleccion(new Set());
    setClientesModal({ show: true, usuario });
    setCargandoVinculos(true);
    const { data, error } = await getUsuarioClientes(usuario.id);
    setCargandoVinculos(false);
    if (error) {
      // No enmascarar la falla como "sin clientes" (10.177): avisar y dejar el modal vacío.
      toast.error("No se pudieron cargar los clientes vinculados");
      return;
    }
    setClientesSeleccion(new Set((data || []).map(Number)));
  };

  const handleCerrarClientes = () => {
    setClientesModal({ show: false, usuario: null });
    setClientesSeleccion(new Set());
    setFiltroClientesModal("");
  };

  const handleToggleCliente = (clienteId) => {
    const idNum = Number(clienteId);
    setClientesSeleccion((prev) => {
      const next = new Set(prev);
      if (next.has(idNum)) next.delete(idNum);
      else next.add(idNum);
      return next;
    });
  };

  const handleGuardarClientes = async () => {
    const usuario = clientesModal.usuario;
    if (!usuario) return;

    setGuardandoClientes(true);
    // createdBy = ID real del usuario que vincula (10.104), NO el placeholder 1.
    const { data, error } = await setUsuarioClientes(usuario.id, [...clientesSeleccion], userId);
    setGuardandoClientes(false);

    if (error) {
      toast.error("Error al guardar los clientes vinculados");
      return;
    }
    // Set vacío es válido (contacto sin clientes → en Fase 2 no ve nada); no es error.
    toast.success(
      data && data.length > 0 ? `${data.length} cliente(s) vinculado(s)` : "Contacto sin clientes vinculados"
    );
    handleCerrarClientes();
  };

  const handleSaveClick = async () => {
    if (editingUser && editingUser.id) {
      const originalUser = usuarios.find((u) => u.id === editingUser.id);
      const isEmailChanged = originalUser && originalUser.email.toLowerCase() !== editingUser.email.toLowerCase();
      const paisCode = paisMap[pais] || "";

      let emailExists = false;
      if (isEmailChanged) {
        emailExists = usuarios.some(
          (usuario) =>
            usuario.email?.toLowerCase() === editingUser.email.toLowerCase() &&
            usuario.id !== editingUser.id &&
            usuario.pais === paisCode
        );
      }

      if (emailExists) {
        setEmailError("Este correo ya está registrado");
        toast.error("Este correo ya está registrado");
        return;
      }

      if ((editingUser.rol === "agencia" || editingUser.rol === "cliente") && !editingUser.cargo) {
        toast.error("Debe seleccionar un cargo");
        return;
      }

      try {
        const updatePayload = {
          id: editingUser.id,
          email: editingUser.email,
          agencia: editingUser.rol === "agencia" ? parseInt(editingUser.entidad, 10) : null,
          cliente_id: editingUser.rol === "cliente" ? parseInt(editingUser.entidad, 10) : null,
          cargo: editingUser.cargo,
          cargo_detalle: editingUser.cargo_detalle || null,
          telefono: editingUser.telefono,
          fecha_nacimiento: editingUser.fecha_nacimiento,
        };
        if (esAdmin) {
          updatePayload.nombre = editingUser.nombre;
          updatePayload.apellido = editingUser.apellido;
          updatePayload.rol = editingUser.rol;
        }
        const updatedUser = await updateUsuario(updatePayload);

        setUsuarios((prev) => prev.map((u) => (u.id === updatedUser.id ? updatedUser : u)));

        setEditingUser(null);
        setIsEditing(false);
        setEmailError("");
        toast.success("Usuario actualizado correctamente");
      } catch (error) {
        console.error("Error saving user:", error);
        toast.error("Error al guardar usuario");
      }
    }
  };

  const handleToggleHabilitado = async (usuario) => {
    const estaActivo = usuario.habilitado !== false;
    if (
      estaActivo &&
      !window.confirm("¿Anular el acceso de este usuario? No podrá iniciar sesión hasta reactivarlo.")
    ) {
      return;
    }
    try {
      const { error } = await setUsuarioHabilitado(usuario.id, !estaActivo);
      if (error) throw error;
      toast.success(estaActivo ? "Acceso anulado" : "Acceso reactivado");
      await fetchUsuarios();
    } catch (error) {
      console.error("Error al cambiar acceso del usuario:", error);
      toast.error("Error al cambiar el acceso");
    }
  };

  const handleDeleteClick = async (usuario) => {
    const confirmMsg = `¿Eliminar DEFINITIVAMENTE a ${usuario.nombre} ${usuario.apellido} (${usuario.email})? Esta acción borra el usuario de forma permanente y NO se puede deshacer. Para una baja reversible usá "Anular acceso".`;
    if (!window.confirm(confirmMsg)) return;

    const { data, error } = await deleteUsuario(usuario.id);

    if (error) {
      if (error.code === "23503") {
        toast.error(
          "No se puede eliminar: el usuario tiene registros asociados (ventas, cobros, contactos, etc.). Usá 'Anular acceso' para una baja reversible."
        );
      } else {
        toast.error("Error al eliminar usuario");
      }
      return; // no remover del estado: el borrado no se concretó
    }

    if (!data || data.length === 0) {
      // 0 filas afectadas (ej. RLS) → no se borró nada, mantener la fila
      toast.error("No se eliminó ningún usuario");
      return;
    }

    setUsuarios((prev) => prev.filter((u) => u.id !== usuario.id));
    toast.success("Usuario eliminado");
  };

  const handleSetPassword = (usuario) => {
    setPasswordInput("");
    setPasswordModal({ show: true, usuario });
  };

  const handleConfirmPassword = async () => {
    const { usuario } = passwordModal;
    if (!passwordInput || passwordInput.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    try {
      const { data, error } = await supabaseClient.functions.invoke("set-user-password", {
        body: { email: usuario.email, password: passwordInput },
      });

      if (error) {
        let serverMsg = "Error al asignar contraseña";
        try {
          const body = await error.context?.json?.();
          if (body?.error) serverMsg = body.error;
        } catch {
          // no body
        }
        toast.error(serverMsg);
        return;
      }

      const result = typeof data === "string" ? JSON.parse(data) : data;
      if (result.success) {
        toast.success("Contraseña asignada correctamente");
        setPasswordModal({ show: false, usuario: null });
      } else {
        toast.error(result.error || "Error al asignar contraseña");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error al asignar contraseña");
    }
  };

  const handleEmailChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, email: e.target.value });
    }
  };

  const handleEntidadChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, entidad: e.target.value });
    }
  };

  const handleCargoChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, cargo: e.target.value });
    }
  };

  const handleCargoDetalleChange = (e) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, cargo_detalle: e.target.value });
    }
  };

  const handleSort = (column) => {
    setSortColumn(column);
    setSortDirection(sortColumn === column && sortDirection === "asc" ? "desc" : "asc");
  };

  // Sort de pendientes: primer click asc, segundo desc; independiente del de usuarios.
  const handleSortPendientes = (column) => {
    if (pendSortColumn === column) {
      setPendSortDirection(pendSortDirection === "asc" ? "desc" : "asc");
    } else {
      setPendSortColumn(column);
      setPendSortDirection("asc");
    }
  };

  const flechaPend = (column) => (pendSortColumn === column ? (pendSortDirection === "asc" ? " ↑" : " ↓") : "");

  const getEntidadNombre = (usuario) => {
    if (usuario.rol === "cliente") {
      const cliente = clientes.find((c) => c.id === usuario.cliente_id);
      return cliente
        ? cliente.empresa === cliente.producto
          ? cliente.nombre
          : `${cliente.empresa} | ${cliente.producto}`
        : "";
    }
    if (usuario.rol === "agencia") {
      return intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "";
    }
    return "";
  };

  const filasPendientesFiltradas = useMemo(() => {
    if (!modoPendientes) return [];
    const filas = construirFilasPendientes({
      pendientes,
      usuarios,
      paisCode: paisMap[pais] || "",
    });

    // Los mismos filtros de texto de la barra aplican sobre los campos inferidos
    // de cada fila. Agencia/Cliente/Cargo no restringen en esta vista.
    const nombreLower = searchNombre.toLowerCase().trim();
    const apellidoLower = searchApellido.toLowerCase().trim();
    const correoLower = searchCorreo.toLowerCase().trim();
    if (!nombreLower && !apellidoLower && !correoLower) return filas;

    return filas.filter(
      (f) =>
        (!nombreLower || (f.nombre || "").toLowerCase().includes(nombreLower)) &&
        (!apellidoLower || (f.apellido || "").toLowerCase().includes(apellidoLower)) &&
        (!correoLower || (f.email || "").toLowerCase().includes(correoLower))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modoPendientes, pendientes, usuarios, pais, searchNombre, searchApellido, searchCorreo]);

  // La sugerencia guarda el ID de la entidad; el nombre se resuelve por ID contra
  // los lookups ya cargados (nunca por string).
  const getSugerenciaNombre = (sugerencia) => {
    if (!sugerencia) return "";
    if (sugerencia.tipo === "agencia") {
      return intermediarios.find((i) => i.id === sugerencia.entidadId)?.nombre || "";
    }
    const cliente = clientes.find((c) => c.id === sugerencia.entidadId);
    if (!cliente) return "";
    return cliente.empresa === cliente.producto ? cliente.nombre : `${cliente.empresa} | ${cliente.producto}`;
  };

  // "2026-07-11" → "11/07/26". Sin Date() para evitar corrimientos de timezone.
  const formatFechaCorta = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.slice(0, 10).split("-");
    if (!y || !m || !d) return "";
    return `${d}/${m}/${y.slice(2)}`;
  };

  // Celda "Frecuencia": "{n} veces | Última dd/mm/aa". Filas sin datos → "—".
  const renderFrecuencia = (fila) => {
    if (!fila.vecesVisto) return "—";
    const veces = fila.vecesVisto === 1 ? "1 vez" : `${fila.vecesVisto} veces`;
    const fecha = formatFechaCorta(fila.ultimaFecha);
    return fecha ? `${veces} | Última ${fecha}` : veces;
  };

  // Orden por header. Sin columna elegida se respeta el orden natural del armado.
  const filasPendientes = useMemo(() => {
    if (!pendSortColumn) return filasPendientesFiltradas;
    const dir = pendSortDirection === "asc" ? 1 : -1;
    const valorDe = (f) => {
      switch (pendSortColumn) {
        case "origen":
          return f.origen || "";
        case "email":
          return f.email || "";
        case "nombre":
          return f.nombre || "";
        case "apellido":
          return f.apellido || "";
        case "dominio":
          return f.dominio || "";
        case "vecesVisto":
          return f.vecesVisto || 0;
        case "sugerencia":
          return getSugerenciaNombre(f.sugerencia) || "";
        default:
          return "";
      }
    };
    return [...filasPendientesFiltradas].sort((a, b) => {
      const va = valorDe(a);
      const vb = valorDe(b);
      if (typeof va === "number" && typeof vb === "number") {
        // Sin datos (0 = filas "—") siempre al final, en asc y en desc.
        const ea = va === 0;
        const eb = vb === 0;
        if (ea && !eb) return 1;
        if (!ea && eb) return -1;
        return (va - vb) * dir;
      }
      return String(va).localeCompare(String(vb), "es") * dir;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filasPendientesFiltradas, pendSortColumn, pendSortDirection, intermediarios, clientes]);

  const sortedUsuarios = usuarios
    .filter((usuario) => {
      const paisCode = paisMap[pais] || "";
      const validPais = usuario.pais === paisCode;
      // Los suspendidos (habilitado === false) solo se muestran al admin [1,4];
      // para el resto se ocultan (defensivo, redundante con el getter).
      const isSuspendido = usuario.habilitado === false;
      if (isSuspendido && !esAdmin) return false;
      const isValid = validPais && usuario.email;
      if (!isValid) return false;
      if (rol === ROLES.INFRAESTRUCTURA && usuario.rol !== "edificio") return false;
      if (filtroRol && !esVistaSentinel && usuario.rol !== filtroRol) return false;

      const searchNombreLower = searchNombre.toLowerCase().trim();
      const searchApellidoLower = searchApellido.toLowerCase().trim();
      const searchCargoLower = searchCargo.toLowerCase().trim();
      const searchCorreoLower = searchCorreo.toLowerCase().trim();

      // Lógica de filtrado por agencia (usa matchAgenciaFilter)
      const agenciaMatch =
        !searchAgencia || (usuario.rol === "agencia" && matchAgenciaFilter(searchAgencia, usuario.agencia, pais));

      // Lógica de filtrado por cliente
      const clienteMatch = searchCliente
        ? usuario.rol === "cliente" && usuario.cliente_id?.toString() === searchCliente
        : true;

      return (
        (!searchNombreLower || usuario.nombre?.toLowerCase().includes(searchNombreLower)) &&
        (!searchApellidoLower || usuario.apellido?.toLowerCase().includes(searchApellidoLower)) &&
        agenciaMatch &&
        clienteMatch &&
        (!searchCargoLower || usuario.cargo?.toLowerCase() === searchCargoLower) &&
        (!searchCorreoLower || usuario.email?.toLowerCase().includes(searchCorreoLower))
      );
    })
    .sort((a, b) => {
      let valueA = a[sortColumn] || "";
      let valueB = b[sortColumn] || "";
      if (sortColumn === "agencia") {
        valueA = getEntidadNombre(a);
        valueB = getEntidadNombre(b);
      }
      return sortDirection === "asc"
        ? String(valueA).localeCompare(String(valueB), "es")
        : String(valueB).localeCompare(String(valueA), "es");
    });

  const formatTelefono = (value, paisUsuario) => {
    const digits = value.replace(/\D/g, "");
    const prefix = paisUsuario === "PER" ? "51" : "56";
    const prefixLen = prefix.length;
    let clean = digits;
    if (clean.startsWith(prefix)) clean = clean.slice(prefixLen);
    if (paisUsuario === "PER") {
      const p1 = clean.slice(0, 3);
      const p2 = clean.slice(3, 6);
      const p3 = clean.slice(6, 9);
      return `+${prefix} ${p1}${p2 ? " " + p2 : ""}${p3 ? " " + p3 : ""}`.trim();
    }
    if (clean.startsWith("9")) clean = clean.slice(1);
    const p1 = clean.slice(0, 4);
    const p2 = clean.slice(4, 8);
    return `+${prefix} 9 ${p1}${p2 ? " " + p2 : ""}`.trim();
  };

  const handleTelefonoChange = (e) => {
    if (!editingUser) return;
    const raw = e.target.value;
    const paisCode = editingUser.pais || paisMap[pais] || "";
    const formatted = raw ? formatTelefono(raw, paisCode) : "";
    setEditingUser({ ...editingUser, telefono: formatted });
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => (word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word))
      .join(" ");
  };

  const getEntidadOptions = () => {
    if (newUser.rol === "agencia") {
      return intermediarios.map((intermediario) => ({
        value: intermediario.id,
        label: intermediario.nombre,
      }));
    }
    if (newUser.rol === "cliente") {
      return clientes.map((cliente) => ({
        value: cliente.id,
        label: cliente.nombre,
      }));
    }
    return [];
  };

  const cargosAgencia = ["Gerente", "Director", "Supervisor", "Planificador", "Asistente"];
  const cargosCliente = [
    "Director de marketing",
    "Gerente de marketing",
    "Subgerente de marketing",
    "Brand manager",
    "Jefe de medios",
    "Asistente de marketing",
  ];

  const getCargoOptions = () => {
    if (newUser.rol === "agencia") return cargosAgencia;
    if (newUser.rol === "cliente") return cargosCliente;
    return [];
  };

  const getCargoOptionsForEdit = (rolParam) => {
    if (rolParam === "agencia") return cargosAgencia;
    if (rolParam === "cliente") return cargosCliente;
    return [];
  };

  const getClienteFilterOptions = () =>
    clientes
      .map((cliente) => ({
        value: cliente.id.toString(),
        label: cliente.empresa === cliente.producto ? cliente.nombre : `${cliente.empresa} | ${cliente.producto}`,
        sortKey: (cliente.empresa === cliente.producto ? cliente.nombre : cliente.empresa).toLowerCase(),
      }))
      .sort((a, b) => a.sortKey.localeCompare(b.sortKey, "es"));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === "nombre" || name === "apellido") {
      processedValue = capitalizeFirstLetter(value.trimEnd());
    } else if (name === "email") {
      processedValue = value.toLowerCase();
      setEmailError("");
    }
    setNewUser((prevUser) => ({
      ...prevUser,
      [name]: processedValue,
      ...(name === "rol" && value === "cliente" ? { entidad: "", edificiosOk: "", cargo: "" } : {}),
      ...(name === "rol" && value === "agencia" ? { entidad: "", edificiosOk: "", cargo: "" } : {}),
      ...(name === "rol" && value === "edificio" ? { entidad: "", cargo: "" } : {}),
    }));
    if (name === "rol") {
      setShowListaEdificios(value === "edificio");
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    const edificiosSeleccionados = methods.getValues("edificiosSeleccionados");

    const paisCode = paisMap[pais] || "";
    // Registro desde pendientes: se valida contra la DB en vivo, no contra el
    // array en memoria (getUsers corta en 5000 y oculta anulados a los no-admin).
    const esRegistroPendiente = Boolean(registroPendiente);

    if (esRegistroPendiente) {
      setGuardandoRegistro(true);
      const { existe, usuario: yaExiste } = await existeUsuarioConEmail({
        email: newUser.email,
        pais: paisCode,
      });
      setGuardandoRegistro(false);

      if (existe === null) {
        toast.error("No se pudo verificar el correo contra la base. No se registró nada.");
        return;
      }
      if (existe) {
        const detalle = [yaExiste?.nombre, yaExiste?.apellido].filter(Boolean).join(" ");
        setEmailError("Este correo ya está registrado");
        toast.error(`Este correo ya está registrado${detalle ? ` (${detalle})` : ""}`);
        return;
      }
    } else {
      const emailExists = usuarios.some(
        (usuario) => usuario.email?.toLowerCase() === newUser.email.toLowerCase() && usuario.pais === paisCode
      );
      if (emailExists) {
        setEmailError("Este correo ya está registrado");
        toast.error("Este correo ya está registrado");
        return;
      }
    }

    if ((newUser.rol === "agencia" || newUser.rol === "cliente") && !newUser.entidad) {
      toast.error(`Debe seleccionar un ${newUser.rol === "agencia" ? "intermediario" : "cliente"}`);
      return;
    }

    // El cargo no siempre se conoce al curar un contacto del CRM: en ese flujo
    // es opcional. En el alta normal se sigue exigiendo.
    if (!esRegistroPendiente && (newUser.rol === "agencia" || newUser.rol === "cliente") && !newUser.cargo) {
      toast.error("Debe seleccionar un cargo");
      return;
    }

    if (newUser.rol === "agencia" && newUser.cargo && !cargosAgencia.includes(newUser.cargo)) {
      toast.error("Cargo inválido para el rol Agencia");
      return;
    }
    if (newUser.rol === "cliente" && newUser.cargo && !cargosCliente.includes(newUser.cargo)) {
      toast.error("Cargo inválido para el rol Cliente");
      return;
    }

    const userWithCountryAndIntermediary = {
      nombre: newUser.nombre,
      apellido: newUser.apellido,
      email: esRegistroPendiente ? newUser.email.trim().toLowerCase() : newUser.email,
      rol: newUser.rol,
      pais: paisMap[pais] || "",
      edificiosOk: newUser.rol === "edificio" ? edificiosSeleccionados : null,
      agencia: newUser.rol === "agencia" ? parseInt(newUser.entidad, 10) : null,
      cliente_id: newUser.rol === "cliente" ? parseInt(newUser.entidad, 10) : null,
      cargo: newUser.cargo || null,
      cargo_detalle: newUser.cargo_detalle || null,
      // Explícito, no confiado al default de columna: el contacto que se registra
      // desde pendientes nace con acceso habilitado.
      ...(esRegistroPendiente ? { habilitado: true } : {}),
    };

    try {
      setGuardandoRegistro(esRegistroPendiente);
      const data = await saveUsuario(userWithCountryAndIntermediary);
      if (Array.isArray(data)) {
        setUsuarios([...usuarios, ...data]);
      } else if (data) {
        setUsuarios([...usuarios, data]);
      }

      // El RPC ya excluye lo que está en usuarios; se saca de la lista local para
      // no tener que recargar los ~53k agregados.
      if (esRegistroPendiente) {
        const emailRegistrado = registroPendiente.email;
        setPendientes((prev) => prev.filter((p) => p.email !== emailRegistrado));
      }

      setNewUser({
        nombre: "",
        apellido: "",
        email: "",
        rol: "",
        edificiosOk: "",
        entidad: "",
        cargo: "",
        cargo_detalle: "",
      });
      setEmailError("");
      setShowModal(false);
      setShowListaEdificios(false);
      setRegistroPendiente(null);
      toast.success(
        esRegistroPendiente ? `${newUser.email} registrado como usuario` : "Usuario agregado correctamente"
      );
    } catch (error) {
      console.error("Error al agregar usuario:", error);
      toast.error("Error al agregar usuario");
    } finally {
      setGuardandoRegistro(false);
    }
  };

  const handleExportEmails = () => {
    try {
      const usuariosExportar = sortedUsuarios.filter(
        (u) =>
          (selectedRoles.agencia && u.rol === "agencia") ||
          (selectedRoles.cliente && u.rol === "cliente") ||
          (selectedRoles.edificio && u.rol === "edificio")
      );

      const correos = usuariosExportar
        .map((u) => u.email?.trim().toLowerCase())
        .filter((email) => email && email.includes("@") && email.includes("."));

      const correosUnicos = [...new Set(correos)];

      if (correosUnicos.length === 0) {
        toast.error("No hay correos válidos para exportar");
        return;
      }

      const roles = Object.keys(selectedRoles)
        .filter((key) => selectedRoles[key])
        .join("-");
      const filename = `correos-${roles}-${paisMap[pais] || "desconocido"}.txt`;
      const blob = new Blob([correosUnicos.join(", ")], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success(`Exportados ${correosUnicos.length} correo(s)`);
    } catch (error) {
      console.error("Error exportando:", error);
      toast.error("Error al exportar");
    }
  };

  const handleOpenModal = () => {
    setNewUser({
      nombre: "",
      apellido: "",
      email: "",
      rol: "",
      edificiosOk: "",
      entidad: "",
      cargo: "",
    });
    setEmailError("");
    setShowListaEdificios(false);
    setRegistroPendiente(null);
    setShowModal(true);
  };

  // Fase 2b: mismo modal que "+ Agregar", precargado desde una fila de pendientes.
  // La sugerencia de dominio (si la hay) resuelve rol y entidad; todo es editable.
  const handleAbrirRegistro = (fila) => {
    const sugerencia = fila.sugerencia;
    setNewUser({
      nombre: fila.nombre || "",
      apellido: fila.apellido || "",
      email: fila.email,
      rol: sugerencia?.tipo || "",
      edificiosOk: "",
      entidad: sugerencia ? String(sugerencia.entidadId) : "",
      cargo: "",
      cargo_detalle: "",
    });
    setEmailError("");
    setShowListaEdificios(false);
    setRegistroPendiente(fila);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowListaEdificios(false);
    setEmailError("");
    setRegistroPendiente(null);
  };

  const filtersContent = (
    <div className={styles.filtersContainer}>
      <input
        type="text"
        placeholder="Nombre"
        value={searchNombre}
        onChange={(e) => setSearchNombre(e.target.value)}
        className={searchNombre ? styles.activeFilter : ""}
      />
      <input
        type="text"
        placeholder="Apellido"
        value={searchApellido}
        onChange={(e) => setSearchApellido(e.target.value)}
        className={searchApellido ? styles.activeFilter : ""}
      />
      <AgenciasDropdown
        value={searchAgencia}
        onChange={(e) => setSearchAgencia(e.target.value)}
        intermediarios={intermediarios}
        placeholder="Agencia"
        className={`form-control ${searchAgencia ? styles.activeFilter : ""}`}
      />
      <select
        value={searchCliente}
        onChange={(e) => setSearchCliente(e.target.value)}
        className={searchCliente ? styles.activeFilter : ""}
      >
        <option value="">Cliente</option>
        {getClienteFilterOptions().map((option, index) => (
          <option key={`filter-cl-${option.value}-${index}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <select
        value={searchCargo}
        onChange={(e) => setSearchCargo(e.target.value)}
        className={searchCargo ? styles.activeFilter : ""}
      >
        <option value="">Cargo</option>
        <optgroup label="Agencia">
          {cargosAgencia.map((cargo, index) => (
            <option key={`cargo-ag-${index}`} value={cargo}>
              {cargo}
            </option>
          ))}
        </optgroup>
        <optgroup label="Cliente">
          {cargosCliente.map((cargo, index) => (
            <option key={`cargo-cl-${index}`} value={cargo}>
              {cargo}
            </option>
          ))}
        </optgroup>
      </select>
      <input
        type="text"
        placeholder="Correo"
        value={searchCorreo}
        onChange={(e) => setSearchCorreo(e.target.value)}
        className={searchCorreo ? styles.activeFilter : ""}
      />
      <select
        value={filtroRol}
        onChange={(e) => setFiltroRol(e.target.value)}
        className={filtroRol ? styles.activeFilter : ""}
      >
        <option value="">Todos los roles</option>
        <option value={PENDIENTES_SENTINEL}>
          Pendientes{modoPendientes && pendientesCargados ? ` (${filasPendientes.length})` : ""}
        </option>
        <option value={BLACKLIST_SENTINEL}>Blacklist ({blacklistCount})</option>
        <option value={DESCARTADOS_SENTINEL}>Descartados ({descartadosCount})</option>
        <option value={SOLOMAILING_SENTINEL}>Solo mailing ({soloMailingCount})</option>
        <option value={REBOTES_SENTINEL}>Rebotes ({rebotesCount})</option>
        {Object.values(ROLES).map((rolValue) => (
          <option key={`filtro-rol-${rolValue}`} value={rolValue}>
            {rolValue.charAt(0).toUpperCase() + rolValue.slice(1)}
          </option>
        ))}
      </select>
      {puedeEditar && (
        <div className={`dropdown ${styles.exportDropdown}`}>
          <button
            className="btn btn-outline-secondary dropdown-toggle"
            type="button"
            id="exportDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Exportar
          </button>
          <ul className={`dropdown-menu ${styles.exportMenu}`} aria-labelledby="exportDropdown">
            <li className={styles.exportItem}>
              <input
                type="checkbox"
                id="check-agencia"
                checked={selectedRoles.agencia}
                onChange={(e) => setSelectedRoles((prev) => ({ ...prev, agencia: e.target.checked }))}
              />
              <label htmlFor="check-agencia">Agencia</label>
            </li>
            <li className={styles.exportItem}>
              <input
                type="checkbox"
                id="check-cliente"
                checked={selectedRoles.cliente}
                onChange={(e) => setSelectedRoles((prev) => ({ ...prev, cliente: e.target.checked }))}
              />
              <label htmlFor="check-cliente">Cliente</label>
            </li>
            <li className={styles.exportItem}>
              <input
                type="checkbox"
                id="check-edificio"
                checked={selectedRoles.edificio}
                onChange={(e) => setSelectedRoles((prev) => ({ ...prev, edificio: e.target.checked }))}
              />
              <label htmlFor="check-edificio">Edificio</label>
            </li>
            <li className={styles.exportBtnContainer}>
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleExportEmails}
                disabled={!selectedRoles.agencia && !selectedRoles.cliente && !selectedRoles.edificio}
              >
                Exportar
              </button>
            </li>
          </ul>
        </div>
      )}
      {puedeEditar && (
        <button type="button" className="btn btn-primary" onClick={handleOpenModal}>
          + Agregar
        </button>
      )}
    </div>
  );

  return (
    <div className={styles.containerUsuarios}>
      <Header expandChildren>{filtersContent}</Header>

      {modoPendientes && (
        <div className={styles.usuariosTable}>
          {loadingPendientes ? (
            <p className={styles.pendientesEstado}>Cargando contactos pendientes…</p>
          ) : (
            <table
              className={`table table-bordered table-hover align-middle ${styles.tablaPendientes}`}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead className="table-dark text-center align-middle">
                <tr>
                  <th
                    className={styles.colBadge}
                    onClick={() => handleSortPendientes("origen")}
                    style={{ cursor: "pointer" }}
                  >
                    Estado{flechaPend("origen")}
                  </th>
                  <th
                    className={styles.colCorreo}
                    onClick={() => handleSortPendientes("email")}
                    style={{ cursor: "pointer" }}
                  >
                    Correo{flechaPend("email")}
                  </th>
                  <th
                    className={styles.colNombre}
                    onClick={() => handleSortPendientes("nombre")}
                    style={{ cursor: "pointer" }}
                  >
                    Nombre{flechaPend("nombre")}
                  </th>
                  <th
                    className={styles.colApellido}
                    onClick={() => handleSortPendientes("apellido")}
                    style={{ cursor: "pointer" }}
                  >
                    Apellido{flechaPend("apellido")}
                  </th>
                  <th
                    className={styles.colDominio}
                    onClick={() => handleSortPendientes("dominio")}
                    style={{ cursor: "pointer" }}
                  >
                    Dominio{flechaPend("dominio")}
                  </th>
                  <th
                    className={styles.colFrecuencia}
                    onClick={() => handleSortPendientes("vecesVisto")}
                    style={{ cursor: "pointer" }}
                  >
                    Frecuencia{flechaPend("vecesVisto")}
                  </th>
                  <th
                    className={styles.colSugerencia}
                    onClick={() => handleSortPendientes("sugerencia")}
                    style={{ cursor: "pointer" }}
                  >
                    Sugerencia{flechaPend("sugerencia")}
                  </th>
                  <th className={styles.colAcciones}>Edit</th>
                </tr>
              </thead>
              <tbody>
                {filasPendientes.map((fila) => {
                  const sugerenciaNombre = getSugerenciaNombre(fila.sugerencia);
                  return (
                    <tr key={fila.id}>
                      <td className={styles.colBadge}>
                        <span className={fila.origen === ORIGEN_NUEVO ? styles.badgeNuevo : styles.badgeSinCablear}>
                          {fila.origen === ORIGEN_NUEVO ? "Nuevo" : "Sin cablear"}
                        </span>
                      </td>
                      <td className={styles.colCorreo}>{fila.email}</td>
                      <td className={styles.colNombre}>{fila.nombre || "—"}</td>
                      <td className={styles.colApellido}>{fila.apellido || "—"}</td>
                      <td className={styles.colDominio}>{fila.dominio}</td>
                      <td className={`${styles.colFrecuencia} text-center`}>{renderFrecuencia(fila)}</td>
                      <td className={styles.colSugerencia}>{sugerenciaNombre || "—"}</td>
                      <td className={styles.colAcciones}>
                        {/* Un único menú kebab por fila (patrón 10.136, <KebabMenu>).
                            "Nuevo" = todavía no existe en usuarios: se registra o
                            se cura hacia `contactos`. "Sin cablear" = ya es
                            usuario, solo le falta la entidad. Cada ítem dispara
                            el mismo handler/modal que antes tenía su botón. */}
                        {puedeEditar && (
                          <KebabMenu
                            ariaLabel="Acciones del contacto"
                            items={
                              fila.origen === ORIGEN_NUEVO
                                ? [
                                    {
                                      label: "Registrar",
                                      tooltip: "Dar de alta como usuario, vinculado a un cliente o agencia",
                                      disabled: curandoEmail === fila.email,
                                      onClick: () => handleAbrirRegistro(fila),
                                    },
                                    {
                                      label: "Asignar dominio a rol…",
                                      tooltip: `Alta masiva de todos los @${fila.dominio} pendientes a un rol`,
                                      onClick: () => handleAbrirAsignarDominio(fila),
                                    },
                                    {
                                      label: "Mailing",
                                      tooltip: "Guardar como contacto de mailing, sin acceso al sistema",
                                      disabled: curandoEmail === fila.email,
                                      onClick: () => handleSoloMailing(fila),
                                    },
                                    {
                                      label: "Descartar",
                                      tooltip: "Marcar como ruido y sacarlo de la lista",
                                      danger: true,
                                      disabled: curandoEmail === fila.email,
                                      onClick: () => handleAbrirDescartar(fila),
                                    },
                                    {
                                      label: "Descartar dominio completo",
                                      tooltip: `Descartar todos los @${fila.dominio} pendientes (reversible)`,
                                      danger: true,
                                      onClick: () => handleAbrirDescartarDominio(fila),
                                    },
                                    {
                                      label: "Blacklist",
                                      tooltip: "Bloquear este email para el envío",
                                      danger: true,
                                      disabled: curandoEmail === fila.email,
                                      onClick: () => handleAbrirBlacklist(fila),
                                    },
                                    {
                                      label: "Blacklist dominio completo",
                                      tooltip: `Bloquear todo @${fila.dominio} para el envío`,
                                      danger: true,
                                      disabled: curandoEmail === fila.email,
                                      onClick: () => handleAbrirBlacklist(fila, BLACKLIST_DOMINIO),
                                    },
                                  ]
                                : [
                                    {
                                      label: "Vincular",
                                      tooltip: "Atar este usuario a su cliente o agencia",
                                      onClick: () => handleAbrirVincular(fila),
                                    },
                                  ]
                            }
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
                {filasPendientes.length === 0 && (
                  <tr>
                    <td colSpan={8} className={styles.pendientesEstado}>
                      No hay contactos pendientes de vincular.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}

      {!esVistaSentinel && (
        <div className={styles.usuariosTable}>
          <table
            className="table table-bordered table-hover align-middle"
            style={{ tableLayout: "fixed", width: "100%" }}
          >
            <thead className="table-dark text-center align-middle">
              <tr>
                <th className={styles.colNombre} onClick={() => handleSort("nombre")} style={{ cursor: "pointer" }}>
                  Nombre {sortColumn === "nombre" && (sortDirection === "asc" ? "↑" : "↓")}
                </th>
                <th className={styles.colApellido} onClick={() => handleSort("apellido")} style={{ cursor: "pointer" }}>
                  Apellido {sortColumn === "apellido" && (sortDirection === "asc" ? "↑" : "↓")}
                </th>
                <th className={styles.colRol} onClick={() => handleSort("rol")} style={{ cursor: "pointer" }}>
                  Rol {sortColumn === "rol" && (sortDirection === "asc" ? "↑" : "↓")}
                </th>
                <th className={styles.colAgencia} onClick={() => handleSort("agencia")} style={{ cursor: "pointer" }}>
                  Agencia o Cliente {sortColumn === "agencia" && (sortDirection === "asc" ? "↑" : "↓")}
                </th>
                <th className={styles.colCargo} onClick={() => handleSort("cargo")} style={{ cursor: "pointer" }}>
                  Cargo {sortColumn === "cargo" && (sortDirection === "asc" ? "↑" : "↓")}
                </th>
                <th className={styles.colCorreo} onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
                  Correo {sortColumn === "email" && (sortDirection === "asc" ? "↑" : "↓")}
                </th>
                <th className={styles.colTelefono}>Teléfono</th>
                <th className={styles.colCumpleanos}>Cumple</th>
                <th className={styles.colEstado}>Acceso</th>
                <th className={styles.colEdit}>Edit</th>
              </tr>
            </thead>
            <tbody>
              {sortedUsuarios.map((usuario) => (
                <tr key={usuario.id} className={usuario.habilitado === false ? styles.filaSuspendido : ""}>
                  <td className={styles.colNombre}>
                    {isEditing && editingUser?.id === usuario.id && esAdmin ? (
                      <input
                        type="text"
                        value={editingUser.nombre || ""}
                        onChange={(e) => setEditingUser({ ...editingUser, nombre: e.target.value })}
                        onBlur={(e) =>
                          setEditingUser({ ...editingUser, nombre: capitalizeFirstLetter(e.target.value.trim()) })
                        }
                        className="form-control"
                        style={{ width: "100%", fontSize: "14px", margin: 0 }}
                      />
                    ) : (
                      usuario.nombre
                    )}
                  </td>
                  <td className={styles.colApellido}>
                    {isEditing && editingUser?.id === usuario.id && esAdmin ? (
                      <input
                        type="text"
                        value={editingUser.apellido || ""}
                        onChange={(e) => setEditingUser({ ...editingUser, apellido: e.target.value })}
                        onBlur={(e) =>
                          setEditingUser({ ...editingUser, apellido: capitalizeFirstLetter(e.target.value.trim()) })
                        }
                        className="form-control"
                        style={{ width: "100%", fontSize: "14px", margin: 0 }}
                      />
                    ) : (
                      usuario.apellido
                    )}
                  </td>
                  <td className={styles.colRol}>
                    {isEditing && editingUser?.id === usuario.id && esAdmin ? (
                      <select
                        value={editingUser.rol || ""}
                        onChange={(e) => {
                          setEditingUser({ ...editingUser, rol: e.target.value, entidad: "", cargo: "" });
                        }}
                        className="form-control"
                        style={{ width: "100%", fontSize: "14px", margin: 0 }}
                      >
                        <option value={ROLES.ADMINISTRATIVO}>Administrativo</option>
                        <option value={ROLES.AGENCIA}>Agencia</option>
                        <option value={ROLES.BOARD}>Board</option>
                        <option value={ROLES.BROKER}>Broker</option>
                        <option value={ROLES.CLIENTE}>Cliente</option>
                        <option value={ROLES.COMERCIAL}>Comercial</option>
                        <option value={ROLES.CONTABLE}>Contable</option>
                        <option value={ROLES.EDIFICIO}>Edificio</option>
                        <option value={ROLES.GERENCIA}>Gerencia</option>
                        <option value={ROLES.INFRAESTRUCTURA}>Infraestructura</option>
                        <option value={ROLES.INVERSOR}>Inversor</option>
                        <option value={ROLES.SUPERADMIN}>Superadmin</option>
                      </select>
                    ) : (
                      usuario.rol?.charAt(0).toUpperCase() + usuario.rol?.slice(1)
                    )}
                  </td>
                  <td className={styles.colAgencia}>
                    {isEditing && editingUser && editingUser.id === usuario.id ? (
                      <select
                        value={editingUser.entidad || ""}
                        onChange={handleEntidadChange}
                        className="form-control"
                        style={{
                          width: "80%",
                          fontSize: "14px",
                          textAlign: "start",
                          margin: "0",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        disabled={editingUser.rol !== "agencia" && editingUser.rol !== "cliente"}
                      >
                        <option value="">
                          Seleccionar {editingUser.rol === "agencia" ? "Intermediario" : "Cliente"}
                        </option>
                        {(editingUser.rol === "agencia"
                          ? intermediarios.map((intermediario) => ({
                              value: intermediario.id,
                              label: intermediario.nombre,
                              keyPrefix: "agencia",
                            }))
                          : editingUser.rol === "cliente"
                            ? clientes.map((cliente) => ({
                                value: cliente.id,
                                label: cliente.producto,
                                keyPrefix: "cliente",
                              }))
                            : []
                        ).map((option) => (
                          <option key={`${option.keyPrefix}-${option.value}`} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                        {usuario.rol === "cliente"
                          ? (() => {
                              const cliente = clientes.find((c) => c.id === usuario.cliente_id);
                              return cliente
                                ? cliente.empresa === cliente.producto
                                  ? cliente.nombre
                                  : `${cliente.empresa} | ${cliente.producto}`
                                : "-";
                            })()
                          : usuario.rol === "agencia"
                            ? intermediarios.find((i) => i.id === usuario.agencia)?.nombre || "-"
                            : "-"}
                      </span>
                    )}
                  </td>
                  <td className={styles.colCargo}>
                    {isEditing && editingUser && editingUser.id === usuario.id ? (
                      <>
                        <select
                          value={editingUser.cargo || ""}
                          onChange={handleCargoChange}
                          className="form-control"
                          style={{
                            width: "80%",
                            fontSize: "14px",
                            textAlign: "start",
                            margin: "0",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          disabled={editingUser.rol !== "agencia" && editingUser.rol !== "cliente"}
                        >
                          <option value="">Seleccionar Cargo</option>
                          {getCargoOptionsForEdit(editingUser.rol).map((cargo, index) => (
                            <option key={`cargo-${index}`} value={cargo}>
                              {cargo}
                            </option>
                          ))}
                        </select>
                        {(editingUser.rol === "agencia" || editingUser.rol === "cliente") && (
                          <input
                            type="text"
                            placeholder="Detalle cargo"
                            value={editingUser.cargo_detalle || ""}
                            onChange={handleCargoDetalleChange}
                            className="form-control mt-1"
                            style={{ width: "80%", fontSize: "12px" }}
                          />
                        )}
                      </>
                    ) : (
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                        {usuario.cargo || "-"}
                        {/* cargo_detalle sigue en DB y editable arriba, pero no se
                            renderiza como sub-línea gris en la vista. */}
                      </span>
                    )}
                  </td>
                  <td className={styles.colCorreo}>
                    {isEditing && editingUser && editingUser.id === usuario.id ? (
                      <div>
                        <input
                          type="email"
                          value={editingUser.email}
                          onChange={handleEmailChange}
                          className="form-control"
                          style={{
                            width: "80%",
                            fontSize: "14px",
                            textAlign: "left",
                            margin: "0",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        />
                        {emailError && <small className="text-danger">{emailError}</small>}
                      </div>
                    ) : (
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                        {usuario.email.toLowerCase()}
                      </span>
                    )}
                  </td>
                  <td className={styles.colTelefono}>
                    {isEditing && editingUser?.id === usuario.id ? (
                      <input
                        type="tel"
                        value={editingUser.telefono || ""}
                        onChange={handleTelefonoChange}
                        placeholder={editingUser.pais === "PER" ? "+51 9XX XXX XXX" : "+56 9 XXXX XXXX"}
                        className="form-control"
                        style={{ width: "100%", fontSize: "14px", margin: 0 }}
                      />
                    ) : (
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                        {usuario.telefono || "-"}
                      </span>
                    )}
                  </td>
                  <td className={styles.colCumpleanos}>
                    {isEditing && editingUser?.id === usuario.id ? (
                      <input
                        type="date"
                        value={editingUser.fecha_nacimiento || ""}
                        onChange={(e) => setEditingUser({ ...editingUser, fecha_nacimiento: e.target.value })}
                        className="form-control"
                        style={{ width: "100%", fontSize: "12px", margin: 0 }}
                      />
                    ) : (
                      <span>
                        {usuario.fecha_nacimiento
                          ? new Date(usuario.fecha_nacimiento + "T12:00:00").toLocaleDateString("es-CL", {
                              day: "numeric",
                              month: "short",
                            })
                          : "-"}
                      </span>
                    )}
                  </td>
                  <td className={styles.colEstado}>
                    {/* Un único estado por celda: obsoleto reemplaza Activo/Anulado (se
                        contradicen). No cambia el dato ni habilitado, es solo el render. */}
                    {obsoletosSet.has(usuario.email?.toLowerCase()) ? (
                      <span
                        className={`${styles.estadoBadge} ${styles.estadoObsoleto}`}
                        title="El correo rebotó y fue marcado como obsoleto"
                      >
                        Obsoleto
                      </span>
                    ) : usuario.habilitado === false ? (
                      <span className={`${styles.estadoBadge} ${styles.estadoSuspendido}`}>Anulado</span>
                    ) : (
                      <span className={`${styles.estadoBadge} ${styles.estadoActivo}`}>Activo</span>
                    )}
                  </td>
                  <td className={styles.colEdit}>
                    {puedeEditar ? (
                      isEditing && editingUser && editingUser.id === usuario.id ? (
                        <div style={{ display: "flex", gap: 12, justifyContent: "center", alignItems: "center" }}>
                          <FiSave
                            onClick={handleSaveClick}
                            style={{ cursor: "pointer", fontSize: "1.15rem" }}
                            title="Guardar"
                          />
                          {puedeSetearPassword && (
                            <FaKey
                              onClick={() => handleSetPassword(usuario)}
                              style={{ cursor: "pointer", fontSize: "1rem" }}
                              title="Asignar contraseña"
                            />
                          )}
                          {esAdmin &&
                            (usuario.habilitado === false ? (
                              <FaUndo
                                onClick={() => handleToggleHabilitado(usuario)}
                                style={{ cursor: "pointer", fontSize: "1rem", color: "#1e7e34" }}
                                title="Reactivar acceso"
                              />
                            ) : (
                              <FaBan
                                onClick={() => handleToggleHabilitado(usuario)}
                                style={{ cursor: "pointer", fontSize: "1rem", color: "#b02a37" }}
                                title="Anular acceso"
                              />
                            ))}
                          {esAdmin && (
                            <FaTrash
                              onClick={() => handleDeleteClick(usuario)}
                              style={{ cursor: "pointer", fontSize: "1rem", color: "#dc3545" }}
                              title="Eliminar definitivamente"
                            />
                          )}
                        </div>
                      ) : (
                        // Un solo control por fila (nunca lápiz + kebab juntos): si la
                        // única acción aplicable es Editar → lápiz; si hay más (según
                        // permisos) → un único KebabMenu con "Editar" + las demás.
                        // Solo presentación: mismos handlers y gates de permiso.
                        (() => {
                          const acciones = [
                            {
                              label: "Editar",
                              icon: <FaEdit />,
                              onClick: () => handleEditClick(usuario),
                            },
                          ];
                          if (usuario.rol === "edificio" && puedeAsignarEdif) {
                            acciones.push({
                              label: "Asignar edificios",
                              tooltip: "Elegir qué edificios ve esta cuenta",
                              onClick: () => handleAbrirEdificios(usuario),
                            });
                          }
                          if (usuario.rol === "agencia" && puedeAsignarCli) {
                            acciones.push({
                              label: "Clientes vinculados",
                              tooltip: "Elegir qué clientes ve este contacto en el reporte fotográfico",
                              onClick: () => handleAbrirClientes(usuario),
                            });
                          }
                          if (puedeSetearPassword) {
                            acciones.push({
                              label: "Asignar contraseña",
                              icon: <FaKey />,
                              onClick: () => handleSetPassword(usuario),
                            });
                          }
                          if (esAdmin) {
                            acciones.push(
                              usuario.habilitado === false
                                ? {
                                    label: "Reactivar acceso",
                                    icon: <FaUndo />,
                                    onClick: () => handleToggleHabilitado(usuario),
                                  }
                                : {
                                    label: "Anular acceso",
                                    icon: <FaBan />,
                                    danger: true,
                                    onClick: () => handleToggleHabilitado(usuario),
                                  },
                              {
                                label: "Eliminar definitivamente",
                                icon: <FaTrash />,
                                danger: true,
                                onClick: () => handleDeleteClick(usuario),
                              }
                            );
                          }

                          return (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              {acciones.length === 1 ? (
                                <FaEdit
                                  onClick={() => handleEditClick(usuario)}
                                  style={{ cursor: "pointer", fontSize: "1.15rem" }}
                                  title="Editar usuario"
                                />
                              ) : (
                                <KebabMenu ariaLabel="Acciones del usuario" items={acciones} />
                              )}
                            </div>
                          );
                        })()
                      )
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {edificiosModal.show && (
        <div className={styles.modalOverlay} onClick={handleCerrarEdificios}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: 960, width: "90%" }}
          >
            <div className={styles.modalHeader}>
              <h3>Asignar edificios</h3>
              <button onClick={handleCerrarEdificios}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                {[edificiosModal.usuario?.nombre, edificiosModal.usuario?.apellido].filter(Boolean).join(" ") ||
                  "(sin nombre)"}
                <br />
                <small style={{ color: "#888" }}>{edificiosModal.usuario?.email}</small>
              </p>
              {/* ListaEdificios lee el país del auth (formato largo "Chile"/"Perú"),
                  que coincide con el del usuario objetivo porque la tabla solo muestra
                  filas del país activo. Pre-marca los edificios ya asignados (CSV). */}
              <FormProvider {...edificiosMethods}>
                <ListaEdificios
                  edificiosPreseleccionados={edificiosModal.usuario?.edificiosOk || ""}
                  forceSubmit={() => {}}
                />
              </FormProvider>
            </div>
            <div className={styles.modalFooter}>
              <button type="button" className="btn btn-secondary" onClick={handleCerrarEdificios}>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleGuardarEdificios}
                disabled={guardandoEdificios}
              >
                {guardandoEdificios ? "Guardando…" : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {clientesModal.show &&
        (() => {
          // Etiqueta del cliente: "Empresa | Producto" (o nombre si coinciden), defensivo
          // ante empresa/producto null (10.97). El listado ya viene filtrado por país
          // (getClientes({ pais })). Filtro de texto local para que sea usable con cientos.
          const labelCliente = (c) => {
            if (c.empresa && c.producto) return c.empresa === c.producto ? c.nombre : `${c.empresa} | ${c.producto}`;
            return c.nombre || c.empresa || c.producto || `Cliente ${c.id}`;
          };
          const q = filtroClientesModal.trim().toLowerCase();
          const clientesFiltrados = q ? clientes.filter((c) => labelCliente(c).toLowerCase().includes(q)) : clientes;
          return (
            <div className={styles.modalOverlay} onClick={handleCerrarClientes}>
              <div
                className={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: 640, width: "90%" }}
              >
                <div className={styles.modalHeader}>
                  <h3>Clientes vinculados</h3>
                  <button onClick={handleCerrarClientes}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                  <p style={{ marginBottom: 12 }}>
                    {[clientesModal.usuario?.nombre, clientesModal.usuario?.apellido].filter(Boolean).join(" ") ||
                      "(sin nombre)"}
                    <br />
                    <small style={{ color: "#888" }}>{clientesModal.usuario?.email}</small>
                  </p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Filtrar clientes…"
                    value={filtroClientesModal}
                    onChange={(e) => setFiltroClientesModal(e.target.value)}
                    style={{ marginBottom: 10 }}
                  />
                  {cargandoVinculos ? (
                    <p className="text-muted">Cargando vínculos…</p>
                  ) : (
                    <>
                      <div style={{ marginBottom: 8, fontSize: "0.85rem", color: "#666" }}>
                        {clientesSeleccion.size} seleccionado(s)
                      </div>
                      <div style={{ maxHeight: "50vh", overflowY: "auto", border: "1px solid #eee", borderRadius: 6 }}>
                        {clientesFiltrados.length === 0 ? (
                          <p className="text-muted" style={{ padding: 12, margin: 0 }}>
                            No hay clientes que coincidan.
                          </p>
                        ) : (
                          clientesFiltrados.map((c) => (
                            <label
                              key={c.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "6px 12px",
                                borderBottom: "1px solid #f2f2f2",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={clientesSeleccion.has(Number(c.id))}
                                onChange={() => handleToggleCliente(c.id)}
                              />
                              <span>{labelCliente(c)}</span>
                            </label>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className={styles.modalFooter}>
                  <button type="button" className="btn btn-secondary" onClick={handleCerrarClientes}>
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleGuardarClientes}
                    disabled={guardandoClientes || cargandoVinculos}
                  >
                    {guardandoClientes ? "Guardando…" : "Guardar"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      {asignarDominioModal.show &&
        (() => {
          const dom = asignarDominioModal.dominio;
          const cantidad = filasPendientes.filter((f) => f.origen === ORIGEN_NUEVO && f.dominio === dom).length;
          const rolLabel =
            { cliente: "Cliente", agencia: "Agencia", edificio: "Edificio", mailing: "Mailing" }[asignarRol] || "…";
          const necesitaEntidad = asignarRol === "cliente" || asignarRol === "agencia";
          const opcionesEntidad =
            asignarRol === "agencia"
              ? intermediarios.map((i) => ({ value: i.id, label: i.nombre }))
              : asignarRol === "cliente"
                ? clientes.map((c) => ({ value: c.id, label: c.nombre }))
                : [];
          const cerrar = () => setAsignarDominioModal({ show: false, dominio: "" });
          const listo = asignarRol && (!necesitaEntidad || asignarEntidad) && !procesandoAsignar;
          return (
            <div className={styles.modalOverlay} onClick={cerrar}>
              <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 520 }}>
                <div className={styles.modalHeader}>
                  <h3>Asignar dominio a rol</h3>
                  <button onClick={cerrar}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                  <p style={{ marginBottom: 12 }}>
                    <strong>
                      {cantidad} contacto{cantidad === 1 ? "" : "s"} de {dom}
                    </strong>
                  </p>
                  <div className={styles.formGroup}>
                    <label htmlFor="asignarRol">Rol</label>
                    <select
                      className="form-control"
                      id="asignarRol"
                      value={asignarRol}
                      onChange={(e) => {
                        setAsignarRol(e.target.value);
                        setAsignarEntidad("");
                      }}
                    >
                      <option value="">Seleccionar rol</option>
                      <option value="cliente">Cliente</option>
                      <option value="agencia">Agencia</option>
                      <option value="edificio">Edificio</option>
                      <option value="mailing">Mailing (solo mailing)</option>
                    </select>
                  </div>
                  {necesitaEntidad && (
                    <div className={styles.formGroup}>
                      <label htmlFor="asignarEntidad">{asignarRol === "agencia" ? "Intermediario" : "Cliente"}</label>
                      <select
                        className="form-control"
                        id="asignarEntidad"
                        value={asignarEntidad}
                        onChange={(e) => setAsignarEntidad(e.target.value)}
                      >
                        <option value="">
                          {asignarRol === "agencia" ? "Seleccionar Intermediario" : "Seleccionar Cliente"}
                        </option>
                        {opcionesEntidad.map((option, index) => (
                          <option key={`asig-${option.value}-${index}`} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {asignarRol && (
                    <p style={{ marginTop: 12, color: "#555" }}>
                      Vas a registrar <strong>{cantidad}</strong> contacto{cantidad === 1 ? "" : "s"} de{" "}
                      <strong>{dom}</strong> como <strong>{rolLabel}</strong>. ¿Confirmás?
                    </p>
                  )}
                </div>
                <div className={styles.modalFooter}>
                  <button type="button" className="btn btn-secondary" onClick={cerrar}>
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleConfirmarAsignarDominio}
                    disabled={!listo}
                  >
                    {procesandoAsignar ? "Procesando…" : "Confirmar"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      {descartarDominioModal.show &&
        (() => {
          const dom = descartarDominioModal.dominio;
          const cantidad = filasPendientes.filter((f) => f.origen === ORIGEN_NUEVO && f.dominio === dom).length;
          const cerrar = () => setDescartarDominioModal({ show: false, dominio: "" });
          return (
            <div className={styles.modalOverlay} onClick={cerrar}>
              <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 460 }}>
                <div className={styles.modalHeader}>
                  <h3>Descartar dominio completo</h3>
                  <button onClick={cerrar}>&times;</button>
                </div>
                <div className={styles.modalBody}>
                  <p style={{ marginBottom: 12 }}>
                    <strong>
                      {cantidad} contacto{cantidad === 1 ? "" : "s"} de {dom}
                    </strong>
                    <br />
                    <small style={{ color: "#888" }}>
                      Van a la vista Descartados (reversible). Para tapar el dominio a futuro, usá Blacklist dominio.
                    </small>
                  </p>
                  <div className={styles.formGroup}>
                    <label htmlFor="motivoDescarteDominio">Motivo (opcional)</label>
                    <input
                      type="text"
                      className="form-control"
                      id="motivoDescarteDominio"
                      value={motivoDescarteDominio}
                      onChange={(e) => setMotivoDescarteDominio(e.target.value)}
                      placeholder="Ej: dominio de proveedor, ruido"
                      autoFocus
                      onKeyDown={(e) => e.key === "Enter" && handleConfirmarDescartarDominio()}
                    />
                  </div>
                  <p style={{ marginTop: 12, color: "#555" }}>
                    Vas a descartar <strong>{cantidad}</strong> contacto{cantidad === 1 ? "" : "s"} de{" "}
                    <strong>{dom}</strong>. ¿Confirmás?
                  </p>
                </div>
                <div className={styles.modalFooter}>
                  <button type="button" className="btn btn-secondary" onClick={cerrar}>
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleConfirmarDescartarDominio}
                    disabled={procesandoDescarteDominio}
                  >
                    {procesandoDescarteDominio ? "Procesando…" : "Descartar"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      {vincularModal.show && (
        <div className={styles.modalOverlay} onClick={() => setVincularModal({ show: false, fila: null })}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
            <div className={styles.modalHeader}>
              <h3>Vincular usuario</h3>
              <button onClick={() => setVincularModal({ show: false, fila: null })}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                {[vincularModal.fila?.nombre, vincularModal.fila?.apellido].filter(Boolean).join(" ") || "(sin nombre)"}
                <br />
                <small style={{ color: "#888" }}>{vincularModal.fila?.email}</small>
                <br />
                <small style={{ color: "#888" }}>Rol: {vincularModal.fila?.rol}</small>
              </p>
              <div className={styles.formGroup}>
                <label htmlFor="entidadVinculo">
                  {vincularModal.fila?.rol === "agencia" ? "Intermediario" : "Cliente"}
                </label>
                <select
                  className="form-control"
                  id="entidadVinculo"
                  value={entidadVinculo}
                  onChange={(e) => setEntidadVinculo(e.target.value)}
                >
                  <option value="">
                    {vincularModal.fila?.rol === "agencia" ? "Seleccionar Intermediario" : "Seleccionar Cliente"}
                  </option>
                  {(vincularModal.fila?.rol === "agencia"
                    ? intermediarios.map((i) => ({ value: i.id, label: i.nombre }))
                    : clientes.map((c) => ({ value: c.id, label: c.nombre }))
                  ).map((option, index) => (
                    <option key={`vinc-${option.value}-${index}`} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setVincularModal({ show: false, fila: null })}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirmarVincular}
                disabled={!entidadVinculo || guardandoVinculo}
              >
                {guardandoVinculo ? "Vinculando…" : "Vincular"}
              </button>
            </div>
          </div>
        </div>
      )}

      {modoBlacklist && (
        <div className={styles.usuariosTable}>
          {/* a) Alta manual */}
          <div className={styles.blacklistForm}>
            <select
              className="form-control"
              value={nuevaEntradaBL.tipo}
              onChange={(e) => setNuevaEntradaBL((prev) => ({ ...prev, tipo: e.target.value }))}
            >
              <option value={BLACKLIST_EMAIL}>Email</option>
              <option value={BLACKLIST_DOMINIO}>Dominio</option>
            </select>
            <input
              type="text"
              className="form-control"
              value={nuevaEntradaBL.valor}
              onChange={(e) => setNuevaEntradaBL((prev) => ({ ...prev, valor: e.target.value }))}
              placeholder={nuevaEntradaBL.tipo === BLACKLIST_DOMINIO ? "ejemplo.com" : "correo@ejemplo.com"}
              onKeyDown={(e) => e.key === "Enter" && handleAgregarBlacklistManual()}
            />
            <select
              className="form-control"
              value={nuevaEntradaBL.pais}
              onChange={(e) => setNuevaEntradaBL((prev) => ({ ...prev, pais: e.target.value }))}
            >
              <option value="">Ambos</option>
              <option value="CHI">Chile</option>
              <option value="PER">Perú</option>
            </select>
            <input
              type="text"
              className="form-control"
              value={nuevaEntradaBL.motivo}
              onChange={(e) => setNuevaEntradaBL((prev) => ({ ...prev, motivo: e.target.value }))}
              placeholder="Motivo (opcional)"
              onKeyDown={(e) => e.key === "Enter" && handleAgregarBlacklistManual()}
            />
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAgregarBlacklistManual}
              disabled={guardandoBL || !nuevaEntradaBL.valor.trim()}
            >
              {guardandoBL ? "Agregando…" : "Agregar"}
            </button>
          </div>

          {/* b) Listado */}
          {loadingBlacklist ? (
            <p className={styles.pendientesEstado}>Cargando…</p>
          ) : blacklistEntradas.length === 0 ? (
            <p className={styles.pendientesEstado}>No hay entradas en blacklist.</p>
          ) : (
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-dark text-center align-middle">
                <tr>
                  <th>Tipo</th>
                  <th>Valor</th>
                  <th>País</th>
                  <th>Motivo</th>
                  <th>Fecha</th>
                  <th>Quitar</th>
                </tr>
              </thead>
              <tbody>
                {blacklistEntradas.map((entrada) => (
                  <tr key={entrada.id}>
                    <td className="text-center">{entrada.tipo === BLACKLIST_DOMINIO ? "Dominio" : "Email"}</td>
                    <td className={styles.blacklistValor}>{entrada.valor}</td>
                    <td className="text-center">{entrada.pais || "Ambos"}</td>
                    <td>{entrada.motivo || "—"}</td>
                    <td className="text-center">{entrada.created_at?.slice(0, 10) || "—"}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleQuitarBlacklist(entrada)}
                      >
                        Quitar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {modoDescartados && (
        <div className={styles.usuariosTable}>
          {loadingContactosVista ? (
            <p className={styles.pendientesEstado}>Cargando…</p>
          ) : contactosVista.length === 0 ? (
            <p className={styles.pendientesEstado}>No hay contactos descartados.</p>
          ) : (
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-dark text-center align-middle">
                <tr>
                  <th>Correo</th>
                  <th>Dominio</th>
                  <th>Motivo</th>
                  <th>Fecha</th>
                  <th>Quitar</th>
                </tr>
              </thead>
              <tbody>
                {contactosVista.map((entrada) => (
                  <tr key={entrada.id}>
                    <td>{entrada.email}</td>
                    <td>{entrada.email?.split("@")[1] || "—"}</td>
                    <td>{entrada.motivo || "—"}</td>
                    <td className="text-center">{formatFechaCorta(entrada.created_at) || "—"}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleQuitarContacto(entrada)}
                      >
                        Quitar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {modoSoloMailing && (
        <div className={styles.usuariosTable}>
          {loadingContactosVista ? (
            <p className={styles.pendientesEstado}>Cargando…</p>
          ) : contactosVista.length === 0 ? (
            <p className={styles.pendientesEstado}>No hay contactos de solo mailing.</p>
          ) : (
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-dark text-center align-middle">
                <tr>
                  <th>Correo</th>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Dominio</th>
                  <th>Fecha</th>
                  <th>Quitar</th>
                </tr>
              </thead>
              <tbody>
                {contactosVista.map((entrada) => (
                  <tr key={entrada.id}>
                    <td>{entrada.email}</td>
                    <td>{entrada.nombre || "—"}</td>
                    <td>{entrada.apellido || "—"}</td>
                    <td>{entrada.email?.split("@")[1] || "—"}</td>
                    <td className="text-center">{formatFechaCorta(entrada.created_at) || "—"}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleQuitarContacto(entrada)}
                      >
                        Quitar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {modoRebotes && (
        <div className={styles.usuariosTable}>
          {loadingRebotes ? (
            <p className={styles.pendientesEstado}>Cargando…</p>
          ) : rebotesVista.length === 0 ? (
            <p className={styles.pendientesEstado}>No hay rebotes duros pendientes.</p>
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => setBulkRebotesModal(true)}
                  disabled={procesandoBulkRebotes}
                >
                  <FaBan style={{ marginRight: 6 }} />
                  Marcar todos como obsoletos
                </button>
              </div>
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-dark text-center align-middle">
                  <tr>
                    <th>Correo</th>
                    <th>Motivo</th>
                    <th>Fecha</th>
                    <th>Dónde está</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {rebotesVista.map((fila) => (
                    <tr key={fila.id}>
                      <td>{fila.email}</td>
                      <td title={fila.diagnostic || ""}>
                        {fila.smtp_status || "—"}
                        {fila.diagnostic
                          ? ` · ${fila.diagnostic.slice(0, 80)}${fila.diagnostic.length > 80 ? "…" : ""}`
                          : ""}
                      </td>
                      <td className="text-center">{formatFechaCorta(fila.fecha_rebote) || "—"}</td>
                      <td className="text-center">
                        {fila.dondeEsta === "usuario" ? "Usuario" : fila.dondeEsta === "contacto" ? "Contacto" : "—"}
                      </td>
                      <td className="text-center">
                        <KebabMenu
                          items={[
                            {
                              label: "Marcar obsoleto",
                              onClick: () => handleMarcarObsoleto(fila),
                              disabled: procesandoRebote === fila.id,
                              tooltip: procesandoRebote === fila.id ? "Procesando…" : undefined,
                              danger: true,
                              icon: <FaBan />,
                            },
                          ]}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      )}

      {bulkRebotesModal && (
        <div className={styles.modalOverlay} onClick={() => setBulkRebotesModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 460 }}>
            <div className={styles.modalHeader}>
              <h3>Marcar todos como obsoletos</h3>
              <button onClick={() => setBulkRebotesModal(false)}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                <strong>
                  {rebotesVista.length} rebote{rebotesVista.length === 1 ? "" : "s"} duro
                  {rebotesVista.length === 1 ? "" : "s"} pendiente{rebotesVista.length === 1 ? "" : "s"}
                </strong>
                <br />
                <small style={{ color: "#888" }}>
                  Salen del circuito (mailing + pendientes). No borra ni toca a los usuarios.
                </small>
              </p>
              <p style={{ marginTop: 12, color: "#555" }}>
                Vas a marcar <strong>{rebotesVista.length}</strong> rebote{rebotesVista.length === 1 ? "" : "s"} como
                obsoleto{rebotesVista.length === 1 ? "" : "s"}. ¿Confirmás?
              </p>
            </div>
            <div className={styles.modalFooter}>
              <button type="button" className="btn btn-secondary" onClick={() => setBulkRebotesModal(false)}>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleBulkRebotes}
                disabled={procesandoBulkRebotes}
              >
                {procesandoBulkRebotes ? "Procesando…" : "Marcar todos"}
              </button>
            </div>
          </div>
        </div>
      )}

      {blacklistModal.show && (
        <div className={styles.modalOverlay} onClick={() => setBlacklistModal({ show: false, fila: null })}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 440 }}>
            <div className={styles.modalHeader}>
              <h3>{blacklistModal.tipo === BLACKLIST_DOMINIO ? "Blacklist de dominio" : "Agregar a blacklist"}</h3>
              <button onClick={() => setBlacklistModal({ show: false, fila: null })}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                {blacklistModal.tipo === BLACKLIST_DOMINIO
                  ? "Se bloquea TODO el dominio (ambos países) para el envío; desaparecen todas sus filas de pendientes."
                  : "Se bloquea este email para el envío y deja de aparecer en pendientes."}
                <br />
                <small style={{ color: "#888" }}>
                  {blacklistModal.tipo === BLACKLIST_DOMINIO
                    ? `@${blacklistModal.fila?.dominio}`
                    : blacklistModal.fila?.email}
                </small>
              </p>
              <div className={styles.formGroup}>
                <label htmlFor="motivoBlacklist">Motivo (opcional)</label>
                <input
                  type="text"
                  className="form-control"
                  id="motivoBlacklist"
                  value={motivoBlacklist}
                  onChange={(e) => setMotivoBlacklist(e.target.value)}
                  placeholder="Ej: pidió no recibir, rebota"
                  autoFocus
                  onKeyDown={(e) => e.key === "Enter" && handleConfirmarBlacklist()}
                />
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setBlacklistModal({ show: false, fila: null })}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirmarBlacklist}
                disabled={curandoEmail === blacklistModal.fila?.email}
              >
                Blacklist
              </button>
            </div>
          </div>
        </div>
      )}

      {descartarModal.show && (
        <div className={styles.modalOverlay} onClick={() => setDescartarModal({ show: false, fila: null })}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 440 }}>
            <div className={styles.modalHeader}>
              <h3>Descartar contacto</h3>
              <button onClick={() => setDescartarModal({ show: false, fila: null })}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                Se marca como ruido y deja de aparecer en pendientes.
                <br />
                <small style={{ color: "#888" }}>{descartarModal.fila?.email}</small>
              </p>
              <div className={styles.formGroup}>
                <label htmlFor="motivoDescarte">Motivo (opcional)</label>
                <input
                  type="text"
                  className="form-control"
                  id="motivoDescarte"
                  value={motivoDescarte}
                  onChange={(e) => setMotivoDescarte(e.target.value)}
                  placeholder="Ej: casilla operativa, proveedor"
                  autoFocus
                  onKeyDown={(e) => e.key === "Enter" && handleConfirmarDescartar()}
                />
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setDescartarModal({ show: false, fila: null })}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirmarDescartar}
                disabled={curandoEmail === descartarModal.fila?.email}
              >
                Descartar
              </button>
            </div>
          </div>
        </div>
      )}

      {passwordModal.show && (
        <div className={styles.modalOverlay} onClick={() => setPasswordModal({ show: false, usuario: null })}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <div className={styles.modalHeader}>
              <h3>Asignar contraseña</h3>
              <button onClick={() => setPasswordModal({ show: false, usuario: null })}>&times;</button>
            </div>
            <div className={styles.modalBody}>
              <p style={{ marginBottom: 12 }}>
                {passwordModal.usuario?.nombre} {passwordModal.usuario?.apellido}
                <br />
                <small style={{ color: "#888" }}>{passwordModal.usuario?.email}</small>
              </p>
              <div className={styles.formGroup}>
                <label htmlFor="passwordInput">Contraseña</label>
                <input
                  type="text"
                  className="form-control"
                  id="passwordInput"
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  autoFocus
                  onKeyDown={(e) => e.key === "Enter" && handleConfirmPassword()}
                />
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setPasswordModal({ show: false, usuario: null })}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirmPassword}
                disabled={passwordInput.length < 6}
              >
                Asignar
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className={styles.modalOverlay} onClick={handleCloseModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>{registroPendiente ? "Registrar contacto" : "Agregar Usuario"}</h3>
              <button onClick={handleCloseModal}>&times;</button>
            </div>
            <FormProvider {...methods}>
              <form onSubmit={handleAddUser}>
                <div className={styles.modalBody}>
                  <div className={styles.formGroup}>
                    <label htmlFor="nombre">Nombre</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nombre"
                      name="nombre"
                      value={newUser.nombre}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimEnd();
                        handleInputChange({ target: { name: "nombre", value: trimmedValue } });
                      }}
                      onBlur={(e) => {
                        const trimmedValue = capitalizeFirstLetter(e.target.value.trimEnd());
                        handleInputChange({ target: { name: "nombre", value: trimmedValue } });
                      }}
                      required
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="apellido">Apellido</label>
                    <input
                      type="text"
                      className="form-control"
                      id="apellido"
                      name="apellido"
                      value={newUser.apellido}
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimEnd();
                        handleInputChange({ target: { name: "apellido", value: trimmedValue } });
                      }}
                      onBlur={(e) => {
                        const trimmedValue = capitalizeFirstLetter(e.target.value.trimEnd());
                        handleInputChange({ target: { name: "apellido", value: trimmedValue } });
                      }}
                      required
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="email">Correo</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={newUser.email}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!value.trim().endsWith(" ")) {
                          handleInputChange({ target: { name: "email", value: value } });
                        }
                      }}
                      onBlur={(e) => {
                        const trimmedValue = e.target.value.trimEnd();
                        if (trimmedValue !== e.target.value) {
                          handleInputChange({ target: { name: "email", value: trimmedValue } });
                        }
                      }}
                      required
                    />
                    {emailError && <small className="text-danger">{emailError}</small>}
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="rol">Rol</label>
                    <select
                      className="form-control"
                      id="rol"
                      name="rol"
                      value={newUser.rol}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled>
                        Seleccionar Rol
                      </option>
                      {puedeVerTodosLosRoles ? (
                        <>
                          <option value={ROLES.ADMINISTRATIVO}>Administrativo</option>
                          <option value={ROLES.AGENCIA}>Agencia</option>
                          <option value={ROLES.BOARD}>Board</option>
                          <option value={ROLES.BROKER}>Broker</option>
                          <option value={ROLES.CLIENTE}>Cliente</option>
                          <option value={ROLES.COMERCIAL}>Comercial</option>
                          <option value={ROLES.CONTABLE}>Contable</option>
                          <option value={ROLES.EDIFICIO}>Edificio</option>
                          <option value={ROLES.GERENCIA}>Gerencia</option>
                          <option value={ROLES.INFRAESTRUCTURA}>Infraestructura</option>
                          <option value={ROLES.INVERSOR}>Inversor</option>
                          <option value={ROLES.SUPERADMIN}>Superadmin</option>
                        </>
                      ) : (
                        <>
                          <option value="agencia">Agencia</option>
                          {rol !== "comercial" && <option value="edificio">Edificio</option>}
                          <option value="cliente">Cliente</option>
                        </>
                      )}
                    </select>
                  </div>
                  {(newUser.rol === "agencia" || newUser.rol === "cliente") && (
                    <>
                      <div className={styles.formGroup}>
                        <label htmlFor="entidad">{newUser.rol === "agencia" ? "Intermediario" : "Cliente"}</label>
                        <select
                          className="form-control"
                          id="entidad"
                          name="entidad"
                          value={newUser.entidad}
                          onChange={handleInputChange}
                        >
                          <option value="">
                            {newUser.rol === "agencia" ? "Seleccionar Intermediario" : "Seleccionar Cliente"}
                          </option>
                          {getEntidadOptions().map((option, index) => (
                            <option key={`${newUser.rol}-${option.value}-${index}`} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className={styles.formGroup}>
                        <label htmlFor="cargo">{registroPendiente ? "Cargo (opcional)" : "Cargo"}</label>
                        <select
                          className="form-control"
                          id="cargo"
                          name="cargo"
                          value={newUser.cargo}
                          onChange={handleInputChange}
                        >
                          <option value="">Seleccionar Cargo</option>
                          {getCargoOptions().map((cargo, index) => (
                            <option key={`new-cargo-${index}`} value={cargo}>
                              {cargo}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className={styles.formGroup}>
                        <label htmlFor="cargo_detalle">Detalle cargo</label>
                        <input
                          type="text"
                          className="form-control"
                          id="cargo_detalle"
                          name="cargo_detalle"
                          placeholder="Ej: Managing Director, Cross Media Planner..."
                          value={newUser.cargo_detalle || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </>
                  )}
                  {showListaEdificios && (
                    <div className="mt-3">
                      <ListaEdificios
                        forceSubmit={() => {
                          const edificiosSeleccionados = methods.getValues("edificiosSeleccionados");
                          setNewUser((prevState) => ({
                            ...prevState,
                            edificiosOk: edificiosSeleccionados,
                          }));
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.modalFooter}>
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={guardandoRegistro}>
                    {registroPendiente ? (guardandoRegistro ? "Registrando…" : "Registrar") : "Agregar Usuario"}
                  </button>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      )}
    </div>
  );
};
